<template>
    <section id="form_section">
        <div class="container">
            <div class="service_header">
                <h1 class="avr_title">Конфігуратор клемних рядів</h1>
                <a href="javascript:void(0)" v-on:click="modal_info = true" class="info_btn">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="info-icon" d="M9.5 5H11.5V7H9.5V5ZM9.5 9H11.5V15H9.5V9ZM10.5 0C4.98 0 0.5 4.48 0.5 10C0.5 15.52 4.98 20 10.5 20C16.02 20 20.5 15.52 20.5 10C20.5 4.48 16.02 0 10.5 0ZM10.5 18C6.09 18 2.5 14.41 2.5 10C2.5 5.59 6.09 2 10.5 2C14.91 2 18.5 5.59 18.5 10C18.5 14.41 14.91 18 10.5 18Z" fill="#356EEF"/>
                    </svg>
                    Опис роботи сервісу
                </a>
            </div>

            <h4 class="title_edited" v-if="!project.editTitle" @click="project.editTitle = true">{{ project.name }}</h4>
            <div class="edit_title_container" style="margin-top: 30px;" v-else>
                <input class="edit_title_input" type="text" maxlength="200" v-model="project.oldName"/>
                <div class="edit_title_container_btns">
                    <a href="#" class="save_title_btn" @click.prevent="() => {project.name = project.oldName; project.editTitle = false }">Зберегти</a>
                    <a href="#" class="cancel_title_btn" @click.prevent="() => { project.oldName = project.name; project.editTitle = false }">Скасувати</a>
                </div>
            </div>

            <h5 class="spec_title">Загальна специфікація</h5>

            <div id="items" class="items">
                <div class="summ_items_container main_table_container" v-if="summarize">
                    <table class="main_table">
                        <tr>
                            <th class="main_table_title" style="width: 42px;">№</th>
                            <th class="main_table_title" style="text-align: left; width: 615px; padding-left:16px;">Найменування</th>
                            <th class="main_table_title" style="width: 145px;">Кількість, шт.</th>
                            <th class="main_table_title" style="width: 183px;">Ціна, грн. <br> без ПДВ</th>
                            <th class="main_table_title" style="width: 185px;">Сума, грн. <br> без ПДВ</th>
                            <th class="main_table_title" style="width: 185px;">Тех. <br> інфо.</th>
                            <th class="main_table_title" style="width: 126px;"></th>
                        </tr>
                        <tr v-for="(acessory, i) in summarizeResult" :key="i">
                            <td class="main_table_row" style="text-align: center;">{{ i+1 }}</td>
                            <td class="main_table_row" style="text-align: left; padding-left:16px;padding-right:12px;">{{ acessory.article + ' ' + acessory.name }}</td>
                            <td class="main_table_row" style="text-align: center;">
                                <input class="main_table_count_input" type="number" min="1" @input="filterKlemaPositiveCountSumm(i)" v-model="acessory.count">
                            </td>
                            <td class="main_table_row" style="text-align: center;">{{ numberWithSpaces( acessory.price/1.2 ) }}</td>
                            <td class="main_table_row" style="text-align: center;">{{ numberWithSpaces( (acessory.price/1.2) * acessory.count ) }}</td>
                            <td class="main_table_row" style="text-align: center;">
                                <a :href="acessory.technical_characteristics" target="_blank">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clip-path="url(#clip0_7132_91719)">
                                        <path d="M11 7.00781H13V9.00781H11V7.00781ZM11 11.0078H13V17.0078H11V11.0078ZM12 2.00781C6.48 2.00781 2 6.48781 2 12.0078C2 17.5278 6.48 22.0078 12 22.0078C17.52 22.0078 22 17.5278 22 12.0078C22 6.48781 17.52 2.00781 12 2.00781ZM12 20.0078C7.59 20.0078 4 16.4178 4 12.0078C4 7.59781 7.59 4.00781 12 4.00781C16.41 4.00781 20 7.59781 20 12.0078C20 16.4178 16.41 20.0078 12 20.0078Z" fill="#356EEF"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_7132_91719">
                                        <rect width="24" height="24" fill="white" transform="translate(0 0.0078125)"/>
                                        </clipPath>
                                    </defs>
                                    </svg>
                                </a>
                            </td>
                            <td class="main_table_row" style="text-align: center;">
                                <div class="edit_row">
                                    <a href="javascript:void(0)" v-tooltip.bottom="'Видалити'" disabled class="disabled">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <g clip-path="url(#clip0_7077_121330)">
                                            <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#B70D09"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7077_121330">
                                            <rect width="24" height="24" fill="white"/>
                                            </clipPath>
                                        </defs>
                                        </svg>
                                    </a>
                                </div>
                            </td>
                        </tr>
                    </table>

                    <div class="mobile_acessories_list_item_container mobile">
                        <div class="mobile_acessories_list_item" :class="{active: mobileOpenedAcessories.includes(i)}" v-for="(klemaAcessory, i) in summarizeResult" :key="i">
                            <div class="mobile_acessories_list_item_header" @click="openMobileAcessories(i)">
                                <span>{{ klemaAcessory.article + ' ' + klemaAcessory.name }}</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clip-path="url(#clip0_7077_121318)">
                                        <path d="M7.41 9.08984L12 13.6698L16.59 9.08984L18 10.4998L12 16.4998L6 10.4998L7.41 9.08984Z" fill="#356EEF"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_7077_121318">
                                        <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div class="mobile_acessories_list_item_content" v-if="mobileOpenedAcessories.includes(i)">
                                <div class="mobile_acessories_list_item_content_row">
                                    <span>#</span>
                                    <span><b>{{ i+1 }}</b></span>
                                </div>
                                <div class="mobile_acessories_list_item_content_row">
                                    <span>Кількість, шт.</span>
                                    <input class="main_table_count_input" type="number" min="1" @input="filterKlemaPositiveCountSumm(i)" v-model="klemaAcessory.count">
                                </div>
                                <div class="mobile_acessories_list_item_content_row">
                                    <span>Ціна, грн. без ПДВ.</span>
                                        <span><b>{{ numberWithSpaces( klemaAcessory.price/1.2 ) }}</b></span>
                                </div>
                                <div class="mobile_acessories_list_item_content_row">
                                    <span>Сума, грн. без ПДВ</span>
                                    <span><b>{{ numberWithSpaces( (klemaAcessory.price/1.2) * klemaAcessory.count ) }}</b></span>
                                </div>
                                <div class="mobile_acessories_list_item_content_row">
                                    <span>Тех. інфо.</span>
                                    <a :href="klemaAcessory.technical_characteristics" target="_blank">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <g clip-path="url(#clip0_7132_91719)">
                                            <path d="M11 7.00781H13V9.00781H11V7.00781ZM11 11.0078H13V17.0078H11V11.0078ZM12 2.00781C6.48 2.00781 2 6.48781 2 12.0078C2 17.5278 6.48 22.0078 12 22.0078C17.52 22.0078 22 17.5278 22 12.0078C22 6.48781 17.52 2.00781 12 2.00781ZM12 20.0078C7.59 20.0078 4 16.4178 4 12.0078C4 7.59781 7.59 4.00781 12 4.00781C16.41 4.00781 20 7.59781 20 12.0078C20 16.4178 16.41 20.0078 12 20.0078Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7132_91719">
                                            <rect width="24" height="24" fill="white" transform="translate(0 0.0078125)"/>
                                            </clipPath>
                                        </defs>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="item_drop_container" :class="{disabled: openedSections.length}" v-else>
                    <div class="item_drop" v-for="(klema, k) in klemyRows" :key="k" :class="{active: openedSections.includes(k)}">
                        <div class="item_header">
                            <div class="item_header-title">
                                <svg class="arrow_opened" @click="openSection(k)" :class="{opened: openedSections.includes(k)}" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clip-path="url(#clip0_7077_121318)">
                                        <path d="M7.41 9.08984L12 13.6698L16.59 9.08984L18 10.4998L12 16.4998L6 10.4998L7.41 9.08984Z" fill="#356EEF"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_7077_121318">
                                        <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <span class="title_edited" v-if="!klema.editTitle" @click="klema.editTitle = true">{{ klema.name }}</span>
                                <div class="edit_title_container" v-else>
                                    <input class="edit_title_input" type="text" maxlength="200" v-model="klema.oldName"/>
                                    <div class="edit_title_container_btns">
                                        <a href="#" class="save_title_btn" @click.prevent="() => {klema.name = klema.oldName; klema.editTitle = false }">Зберегти</a>
                                        <a href="#" class="cancel_title_btn" @click.prevent="() => { klema.oldName = klema.name; klema.editTitle = false }">Скасувати</a>
                                    </div>
                                </div>
                            </div>
                            <div class="item_header-actions">
                                <a href="javascript:void(0)" v-tooltip.bottom="'Додати'" class="item_header-action action-add" @click.prevent="addItemAcessory(k)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clip-path="url(#clip0_7077_121324)">
                                        <path d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#356EEF"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_7077_121324">
                                        <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                    </defs>
                                    </svg>
                                </a>
                                <a href="javascript:void(0)" v-tooltip.bottom="'Копіювати'" class="item_header-action action-copy" @click="copyItem(k)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clip-path="url(#clip0_7077_121327)">
                                        <path d="M13 11H11V14H8V16H11V19H13V16H16V14H13V11ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z" fill="#356EEF"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_7077_121327">
                                        <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                    </defs>
                                    </svg>
                                </a>
                                <a href="javascript:void(0)" v-tooltip.bottom="'Видалити'" :class="{disabled: klemyRows.length < 2}" class="item_header-action action-delete" @click="deleteItem(k)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clip-path="url(#clip0_7077_121330)">
                                        <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#B70D09"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_7077_121330">
                                        <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                    </defs>
                                    </svg>
                                </a>
                            </div>
                            <div class="item_header_info mobile" v-if="openedSections.includes(k)">
                                <p class="item_text mobile" v-if="klema.acessories.length">Загальна довжина клемного ряду <b> {{ getTotalWidth(klema.acessories) }} мм </b> </p>
                                <div class="item_header_info_actions">
                                    <a href="javascript:void(0)" class="item_header-action action-add" @click.prevent="addItemAcessory(k)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <g clip-path="url(#clip0_7077_121324)">
                                            <path d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7077_121324">
                                            <rect width="24" height="24" fill="white"/>
                                            </clipPath>
                                        </defs>
                                        </svg>
                                        Додати елемент
                                    </a>
                                    <a href="javascript:void(0)" :class="{disabled: klemyRows.length < 2}" class="item_header-action action-delete" @click="deleteItem(k)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <g clip-path="url(#clip0_7077_121330)">
                                            <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#B70D09"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7077_121330">
                                            <rect width="24" height="24" fill="white"/>
                                            </clipPath>
                                        </defs>
                                        </svg>
                                        Видалити ряд
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="item_content" v-if="openedSections.includes(k)">
                            <p class="item_text" v-if="klema.acessories.length">Загальна довжина клемного ряду <b> {{ getTotalWidth(klema.acessories) }} мм </b> </p>
                            <div class="main_table_container">
                                <table class="main_table" v-if="klema.acessories">
                                    <tr>
                                        <th class="main_table_title" style="width: 42px;">№</th>
                                        <th class="main_table_title" style="text-align: left; width: 615px; padding-left:16px;">Найменування</th>
                                        <th class="main_table_title" style="width: 145px;">Кількість, шт.</th>
                                        <th class="main_table_title" style="width: 183px;">Ціна, грн. <br> без ПДВ</th>
                                        <th class="main_table_title" style="width: 185px;">Сума, грн. <br> без ПДВ</th>
                                        <th class="main_table_title" style="width: 185px;">Тех. <br> інфо.</th>
                                        <th class="main_table_title" style="width: 126px;"></th>
                                    </tr>
                                    <tr v-for="(klemaAcessory, i) in klema.acessories" :key="k+i">
                                        <td class="main_table_row" style="text-align: center;">{{ i+1 }}</td>
                                        <td class="main_table_row" style="text-align: left; padding-left:16px;padding-right:12px;">{{ klemaAcessory.article + ' ' + klemaAcessory.name }}</td>
                                        <td class="main_table_row" style="text-align: center;">
                                            <input class="main_table_count_input" type="number" @input="filterKlemaPositiveCount(k, i)" min="1" v-model="klemaAcessory.count">
                                        </td>
                                        <td class="main_table_row" style="text-align: center;">{{ numberWithSpaces( klemaAcessory.price/1.2 ) }}</td>
                                        <td class="main_table_row" style="text-align: center;">{{ numberWithSpaces( (klemaAcessory.price/1.2) * klemaAcessory.count ) }}</td>
                                        <td class="main_table_row" style="text-align: center;">
                                            <a :href="klemaAcessory.technical_characteristics" target="_blank">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <g clip-path="url(#clip0_7132_91719)">
                                                    <path d="M11 7.00781H13V9.00781H11V7.00781ZM11 11.0078H13V17.0078H11V11.0078ZM12 2.00781C6.48 2.00781 2 6.48781 2 12.0078C2 17.5278 6.48 22.0078 12 22.0078C17.52 22.0078 22 17.5278 22 12.0078C22 6.48781 17.52 2.00781 12 2.00781ZM12 20.0078C7.59 20.0078 4 16.4178 4 12.0078C4 7.59781 7.59 4.00781 12 4.00781C16.41 4.00781 20 7.59781 20 12.0078C20 16.4178 16.41 20.0078 12 20.0078Z" fill="#356EEF"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_7132_91719">
                                                    <rect width="24" height="24" fill="white" transform="translate(0 0.0078125)"/>
                                                    </clipPath>
                                                </defs>
                                                </svg>
                                            </a>
                                        </td>
                                        <td class="main_table_row" style="text-align: center;">
                                            <div class="edit_row">
                                                <a href="javascript:void(0)" v-tooltip.bottom="'Видалити'" @click.prevent="deleteAccesoryItem(k, i, klemaAcessory)">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clip-path="url(#clip0_7077_121330)">
                                                        <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#B70D09"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_7077_121330">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                    </svg>
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                </table>

                                <div class="mobile_acessories_list mobile">
                                    <div class="mobile_acessories_list_item" :class="{active: mobileOpenedAcessories.includes(k+'.'+i)}" v-for="(klemaAcessory, i) in klema.acessories" :key="k+i">
                                        <div class="mobile_acessories_list_item_header" @click="openMobileAcessories(k+'.'+i)">
                                            <span>{{ klemaAcessory.article + ' ' + klemaAcessory.name }}</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <g clip-path="url(#clip0_7077_121318)">
                                                    <path d="M7.41 9.08984L12 13.6698L16.59 9.08984L18 10.4998L12 16.4998L6 10.4998L7.41 9.08984Z" fill="#356EEF"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_7077_121318">
                                                    <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                        <div class="mobile_acessories_list_item_content" v-if="mobileOpenedAcessories.includes(k+'.'+i)">
                                            <div class="mobile_acessories_list_item_content_row">
                                                <span>#</span>
                                                <span><b>{{ i+1 }}</b></span>
                                            </div>
                                            <div class="mobile_acessories_list_item_content_row">
                                                <span>Кількість, шт.</span>
                                                <input class="main_table_count_input" type="number" @input="filterKlemaPositiveCount(k, i)" min="1" v-model="klemaAcessory.count">
                                            </div>
                                            <div class="mobile_acessories_list_item_content_row">
                                                <span>Ціна, грн. без ПДВ.</span>
                                                <span><b>{{ numberWithSpaces( klemaAcessory.price/1.2 ) }}</b></span>
                                            </div>
                                            <div class="mobile_acessories_list_item_content_row">
                                                <span>Сума, грн. без ПДВ</span>
                                                <span><b>{{ numberWithSpaces( (klemaAcessory.price/1.2) * klemaAcessory.count ) }}</b></span>
                                            </div>
                                            <div class="mobile_acessories_list_item_content_row">
                                                <span>Тех. інфо.</span>
                                                <a :href="klemaAcessory.technical_characteristics" target="_blank">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clip-path="url(#clip0_7132_91719)">
                                                        <path d="M11 7.00781H13V9.00781H11V7.00781ZM11 11.0078H13V17.0078H11V11.0078ZM12 2.00781C6.48 2.00781 2 6.48781 2 12.0078C2 17.5278 6.48 22.0078 12 22.0078C17.52 22.0078 22 17.5278 22 12.0078C22 6.48781 17.52 2.00781 12 2.00781ZM12 20.0078C7.59 20.0078 4 16.4178 4 12.0078C4 7.59781 7.59 4.00781 12 4.00781C16.41 4.00781 20 7.59781 20 12.0078C20 16.4178 16.41 20.0078 12 20.0078Z" fill="#356EEF"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_7132_91719">
                                                        <rect width="24" height="24" fill="white" transform="translate(0 0.0078125)"/>
                                                        </clipPath>
                                                    </defs>
                                                    </svg>
                                                </a>
                                            </div>
                                            <div class="mobile_acessories_list_item_content_row">
                                                <span>Видалити з клемного ряду</span>
                                                <a href="javascript:void(0)" class="item_header-action action-delete" @click.prevent="deleteAccesoryItem(k, i, klemaAcessory)">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clip-path="url(#clip0_7077_121330)">
                                                        <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#B70D09"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_7077_121330">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                    </svg>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <a href="javascript:void(0)" class="mobile_acessories_list_copy_btn" @click="copyItem(k)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <g clip-path="url(#clip0_7077_121327)">
                                                <path d="M13 11H11V14H8V16H11V19H13V16H16V14H13V11ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z" fill="#356EEF"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7077_121327">
                                                <rect width="24" height="24" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <span>Скопіювати цей клемний ряд </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="items_bottom">
                    <a href="javascript:void(0)" v-if="summarize" class="add_item_btn disabled" disabled>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                            <g clip-path="url(#clip0_7077_121363)">
                                <path d="M13 7.01758H11V11.0176H7V13.0176H11V17.0176H13V13.0176H17V11.0176H13V7.01758ZM12 2.01758C6.49 2.01758 2 6.50758 2 12.0176C2 17.5276 6.49 22.0176 12 22.0176C17.51 22.0176 22 17.5276 22 12.0176C22 6.50758 17.51 2.01758 12 2.01758ZM12 20.0176C7.59 20.0176 4 16.4276 4 12.0176C4 7.60758 7.59 4.01758 12 4.01758C16.41 4.01758 20 7.60758 20 12.0176C20 16.4276 16.41 20.0176 12 20.0176Z" fill="#356EEF"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_7077_121363">
                                <rect width="24" height="24" fill="white" transform="translate(0 0.0175781)"/>
                                </clipPath>
                            </defs>
                        </svg>
                        Додати клемний ряд
                    </a>
                    <a href="javascript:void(0)" v-else class="add_item_btn" @click="addItem()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                            <g clip-path="url(#clip0_7077_121363)">
                                <path d="M13 7.01758H11V11.0176H7V13.0176H11V17.0176H13V13.0176H17V11.0176H13V7.01758ZM12 2.01758C6.49 2.01758 2 6.50758 2 12.0176C2 17.5276 6.49 22.0176 12 22.0176C17.51 22.0176 22 17.5276 22 12.0176C22 6.50758 17.51 2.01758 12 2.01758ZM12 20.0176C7.59 20.0176 4 16.4276 4 12.0176C4 7.60758 7.59 4.01758 12 4.01758C16.41 4.01758 20 7.60758 20 12.0176C20 16.4276 16.41 20.0176 12 20.0176Z" fill="#356EEF"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_7077_121363">
                                <rect width="24" height="24" fill="white" transform="translate(0 0.0175781)"/>
                                </clipPath>
                            </defs>
                        </svg>
                        Додати клемний ряд
                    </a>

                    <div class="totals_summs">
                        <div class="total_btns" v-if="totalSumm() === '0,00'">
                            <a href="javascript:void(0)" class="view_spec_btn disabled" disabled>Завантажити специфікацію в Excel</a>
                            <a href="javascript:void(0)" class="download_spec disabled" disabled>
                                <span v-if="!summarize">Підсумувати</span>
                                <span v-if="summarize">Розділити</span>
                            </a>
                        </div>
                        <div class="total_btns" v-else>
                            <a class="view_spec_btn" v-on:click="() => { getExcel() }">Завантажити специфікацію в Excel</a>
                            <a href="javascript:void(0)" v-on:click="doSummarize()" class="download_spec">
                                <span v-if="!summarize">Підсумувати</span>
                                <span v-if="summarize">Розділити</span>
                            </a>
                        </div>
                        <div class="total_prices">
                            <div class="total_prices_price">
                                <p>Разом без ПДВ</p>
                                <p class="price_num">{{ totalSumm() }}</p>
                            </div>
                            <div class="total_prices_price">
                                <p>ПДВ</p>
                                <p class="price_num">{{ pdv() }}</p>
                            </div>
                            <div class="total_prices_price">
                                <p>Разом з ПДВ</p>
                                <p class="price_num">{{ summPdv() }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="commercial_offer">
                        <div class="commercial_offer_header" @click="dropCommercialOfferForm()">
                            <span class="commercial_offer_header_title">Замовити комерційну пропозицію</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" :class="{commercial_offer_drop_row: is_drop_commercial_offer}">
                                <g clip-path="url(#clip0_7979_151607)">
                                    <path d="M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z" fill="#356EEF"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_7979_151607">
                                    <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="commercial_offer_body" v-if="is_drop_commercial_offer">
                            <p class="commercial_offer_body_subtitle">Заповніть форму</p>
                            
                            <div class="flex-group customer_info">
                                <div class="flex_form">
                                    <div class="flex-row">
                                        <div class="form_grid">
                                            <div class="form_group">
                                                <label class="form_label">Організація</label>
                                                <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.organization }" v-model="commercialOfferData.organization" type="text" placeholder="Назва" />
                                            </div>
                                            <div class="form_group">
                                                <label class="form_label">Контактна особа</label>
                                                <input class="form_input" v-model="commercialOfferData.name" type="text" placeholder="ПІБ" />
                                            </div>
                                        </div>
                                        <div class="form_grid">
                                            <div class="form_group">
                                                <label class="form_label">Номер телефону *</label>
                                                <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.phone }" @input="acceptNumber" v-model="commercialOfferData.phone" type="text" placeholder="+380" />
                                                <p class="error_text" v-if="commercialOfferDataErrors.phone">Обов'язкове поле</p>
                                            </div>
                                            <div class="form_group">
                                                <label class="form_label">Електронна пошта *</label>
                                                <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.email }" v-model="commercialOfferData.email" type="text" placeholder="Email" />
                                                <p class="error_text" v-if="commercialOfferDataErrors.email">Обов'язкове поле</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex_form">
                                    <div class="form_group mr-9">
                                        <label class="form_label">Комментар до замовлення</label>
                                        <div class="textarea_container">
                                            <textarea v-model="commercialOfferData.comment" class="form_input form_textarea" maxlength="200" rows="5" placeholder="Коментар"></textarea>
                                            <span class="total_words">{{ commercialOfferData.comment ? commercialOfferData.comment.length : 0 }} / 200</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="commercial_offer_order" v-if="commercial_offer_sended">
                                <div class="block_row">
                                    <p class="commercial_offer_order_title">Заявка №{{commercial_offer_id}} від</p>
                                    <svg id="close_offer" @click="() => {commercial_offer_sended = false; is_disable_commercial_offer_btn = false}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"></path>
                                    </svg>
                                </div>
                                <p class="commercial_offer_order_title">{{commercial_offer_created_at}}</p>
                                <p class="commercial_offer_order_text">Ваша запит на Комерційну пропозицію  зареєстрований та прийнятий, найближчим часом наш менеджер з Вами зв’яжеться. </p>
                            </div>

                            <a href="javascript:void(0)" v-if="!commercial_offer_sended" :disabled="is_disable_commercial_offer_btn" class="commercial_offer_order_btn" @click="commercialOrder()">
                                <template v-if="is_disable_commercial_offer_btn">
                                    Зачекайте... <ProgressSpinner strokeWidth="5" style="width: 30px; height: 30px; margin: 0; margin-left: 30px;" />
                                </template>
                                <template v-else>Замовити</template>
                            </a>
                            <a href="javascript:void(0)" v-else class="commercial_offer_order_btn disabled">
                                Замовити
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div id="klemy" class="filter_section">
                <div class="filter_section_header">
                    <div class="filter_section_header_title_container">
                        <h4>Клеми</h4>
                        <div class="badge_container">
                            <div class="badge" v-if="selected_klemy_filters_count || searchKlemaTitle">
                                <span class="badge_title">
                                    Обрано {{ klemy.length }} клеми
                                </span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" @click.prevent="clearKlemyFilters()">
                                    <g clip-path="url(#clip0_7053_106435)">
                                        <path d="M12.6654 4.77398L11.7254 3.83398L7.9987 7.56065L4.27203 3.83398L3.33203 4.77398L7.0587 8.50065L3.33203 12.2273L4.27203 13.1673L7.9987 9.44065L11.7254 13.1673L12.6654 12.2273L8.9387 8.50065L12.6654 4.77398Z" fill="black"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_7053_106435">
                                        <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="search_input">
                        <input placeholder="Пошук клем..." v-model="searchKlemaTitle" @input="() => { searchKlemy(); this.pageNumberKlemy = 1; }">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-if="!searchKlemaTitle || searchKlemaTitle.length < 2">
                            <g clip-path="url(#clip0_7038_110310)">
                                <path d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z" fill="#356EEF"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_7038_110310">
                                <rect width="24" height="24" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                        <svg class="clear_input" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-else @click.prevent="() => { searchKlemaTitle=null; this.pageNumberKlemy = 1; searchKlemy(); }">
                            <g clip-path="url(#clip0_7077_121330)">
                                <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#B70D09"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_7077_121330">
                                <rect width="24" height="24" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
                <div class="filter_select_badges" v-if="!selectedAcessories.length">
                    <CustomMultiselect
                        v-for="(options, title) in klemy_filters" :key="title"
                        :def="title"
                        :drop="filterDrop"
                        :options="options"
                        :selected-options="selected_klemy_filters[title] ? selected_klemy_filters[title] : []"
                        class="select"
                        @droped="(title) => closeFilters(title)"
                        @modelValue="(option) => selectFilterKlemy(title, option)"
                        @clear="() => { selected_klemy_filters_count = selected_klemy_filters_count - selected_klemy_filters[title].length; selected_klemy_filters[title] = []; filterData(); }"
                    />
                </div>
                <div class="main_table_container">
                    <table class="main_table">
                        <tr>
                            <th class="main_table_title" style="text-align: left; width: 105px; padding-left:16px;">Артикул</th>
                            <th class="main_table_title" style="text-align: left; width: 615px; padding-left:16px;">Найменування</th>
                            <th class="main_table_title" style="width: 105px;">Ціна, грн. <br> без ПДВ</th>
                            <th class="main_table_title" style="width: 129px;">Додати до <br> специфікації</th>
                            <th class="main_table_title" style="width: 134px;">Переглянути <br> аксесуари</th>
                            <th class="main_table_title" style="width: 78px;">Тех. <br> інфо.</th>
                        </tr>
                        <tr v-for="(klema, i) in paginatedKlemy()" :key="i" :class="{active: selectedKlemas.includes(klema.article)}">
                            <td class="main_table_row" style="text-align: left; padding-left:16px;padding-right:12px;"><a href="javascript:void(0)" class="article_copy" @click.stop="copyText(klema.article)" v-tooltip.bottom="'Копіювати артикул'">{{ klema.article }}</a></td>
                            <td class="main_table_row" style="text-align: left; padding-left:16px;padding-right:12px;">{{ klema.article }} {{ klema.name }}</td>
                            <td class="main_table_row" style="text-align: center;">{{ numberWithSpaces( klema.price/1.2 ) }}</td>
                            <td class="main_table_row" style="text-align: center;">
                                <a href="javascript:void(0)" v-tooltip.bottom="'Додати до специфікації'" @click.prevent="addToSpecificationModal(klema)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <g clip-path="url(#clip0_7132_41516)">
                                            <path d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7132_41516">
                                            <rect width="24" height="24" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </a>
                            </td>
                            <td class="main_table_row" style="text-align: center;">
                                <a href="#" v-tooltip.bottom="'Переглянути аксесуари'" @click.prevent="viewAcessoriesByItem(i, klema)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none" v-if="selectedKlemas.includes(klema.article)">
                                        <path d="M12.5 16C13.75 16 14.8125 15.5625 15.6875 14.6875C16.5625 13.8125 17 12.75 17 11.5C17 10.25 16.5625 9.1875 15.6875 8.3125C14.8125 7.4375 13.75 7 12.5 7C11.25 7 10.1875 7.4375 9.3125 8.3125C8.4375 9.1875 8 10.25 8 11.5C8 12.75 8.4375 13.8125 9.3125 14.6875C10.1875 15.5625 11.25 16 12.5 16ZM12.5 14.2C11.75 14.2 11.1125 13.9375 10.5875 13.4125C10.0625 12.8875 9.8 12.25 9.8 11.5C9.8 10.75 10.0625 10.1125 10.5875 9.5875C11.1125 9.0625 11.75 8.8 12.5 8.8C13.25 8.8 13.8875 9.0625 14.4125 9.5875C14.9375 10.1125 15.2 10.75 15.2 11.5C15.2 12.25 14.9375 12.8875 14.4125 13.4125C13.8875 13.9375 13.25 14.2 12.5 14.2ZM12.5 19C10.0667 19 7.85 18.3208 5.85 16.9625C3.85 15.6042 2.4 13.7833 1.5 11.5C2.4 9.21667 3.85 7.39583 5.85 6.0375C7.85 4.67917 10.0667 4 12.5 4C14.9333 4 17.15 4.67917 19.15 6.0375C21.15 7.39583 22.6 9.21667 23.5 11.5C22.6 13.7833 21.15 15.6042 19.15 16.9625C17.15 18.3208 14.9333 19 12.5 19ZM12.5 17C14.3833 17 16.1125 16.5042 17.6875 15.5125C19.2625 14.5208 20.4667 13.1833 21.3 11.5C20.4667 9.81667 19.2625 8.47917 17.6875 7.4875C16.1125 6.49583 14.3833 6 12.5 6C10.6167 6 8.8875 6.49583 7.3125 7.4875C5.7375 8.47917 4.53333 9.81667 3.7 11.5C4.53333 13.1833 5.7375 14.5208 7.3125 15.5125C8.8875 16.5042 10.6167 17 12.5 17Z" fill="#356EEF"/>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-else>
                                        <g clip-path="url(#clip0_7132_41513)">
                                            <path d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z" fill="#AFBBC7"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7132_41513">
                                            <rect width="24" height="24" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </a>
                            </td>
                            <td class="main_table_row" style="text-align: center;">
                                <a :href="klema.technical_characteristics" target="_blank">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clip-path="url(#clip0_7132_91719)">
                                        <path d="M11 7.00781H13V9.00781H11V7.00781ZM11 11.0078H13V17.0078H11V11.0078ZM12 2.00781C6.48 2.00781 2 6.48781 2 12.0078C2 17.5278 6.48 22.0078 12 22.0078C17.52 22.0078 22 17.5278 22 12.0078C22 6.48781 17.52 2.00781 12 2.00781ZM12 20.0078C7.59 20.0078 4 16.4178 4 12.0078C4 7.59781 7.59 4.00781 12 4.00781C16.41 4.00781 20 7.59781 20 12.0078C20 16.4178 16.41 20.0078 12 20.0078Z" fill="#356EEF"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_7132_91719">
                                        <rect width="24" height="24" fill="white" transform="translate(0 0.0078125)"/>
                                        </clipPath>
                                    </defs>
                                    </svg>
                                </a>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="table_pagination_container">
                    <div class="table_pagination">
                        <span>Показано</span>
                        <select class="table_pagination_pages" name="select" v-model="sizeKlemy" @change="pageNumberKlemy = 1">
                            <option :value="5">1-5</option>
                            <option :value="10">1-10</option>
                            <option :value="15" selected>1-15</option>
                            <option :value="20" selected>1-20</option>
                        </select>
                        <span>{{ klemyPageLength() }} з {{ klemy.length }}</span>
                        <div class="pagination_bnts">
                            <a href="javascript:void(0)" class="pagination_bnt" @click="prevPage()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                                <path d="M7.91016 1.41L3.33016 6L7.91016 10.59L6.50016 12L0.500156 6L6.50016 0L7.91016 1.41Z" fill="black"/>
                                </svg>
                            </a>
                            <a href="javascript:void(0)" class="pagination_bnt" @click="nextPage()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                                <path d="M0.0898438 1.41L4.66984 6L0.0898438 10.59L1.49984 12L7.49984 6L1.49984 0L0.0898438 1.41Z" fill="black"/>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div id="acessories" class="filter_section">
                <div class="filter_section_header">
                    <div class="filter_section_header_title_container">
                        <h4>Аксесуари</h4>
                        <div class="badge_container">
                            <div class="badge" v-if="filterAcessoryKlemas.length || selected_acessories_filters.length || searchAcessoryTitle">
                                <span class="badge_title">
                                    Обрано {{ acessories.length }} аксесуари
                                </span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" @click.prevent="clearAcessoryFilters()">
                                    <g clip-path="url(#clip0_7053_106435)">
                                        <path d="M12.6654 4.77398L11.7254 3.83398L7.9987 7.56065L4.27203 3.83398L3.33203 4.77398L7.0587 8.50065L3.33203 12.2273L4.27203 13.1673L7.9987 9.44065L11.7254 13.1673L12.6654 12.2273L8.9387 8.50065L12.6654 4.77398Z" fill="black"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_7053_106435">
                                        <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="search_input">
                        <input placeholder="Пошук аксесуарів..." v-model="searchAcessoryTitle" @input="() => { searchAccesory(); this.pageNumberAccesory = 1; }">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-if="!searchAcessoryTitle || searchAcessoryTitle.length < 2">
                            <g clip-path="url(#clip0_7038_110310)">
                                <path d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z" fill="#356EEF"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_7038_110310">
                                <rect width="24" height="24" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                        <svg class="clear_input" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-else @click.prevent="() => { searchAcessoryTitle=null; this.pageNumberAccesory = 1; searchAccesory(); }">
                            <g clip-path="url(#clip0_7077_121330)">
                                <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#B70D09"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_7077_121330">
                                <rect width="24" height="24" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>

                <div class="filter_badges" style="margin-bottom: 10px;">
                    <template v-for="(option, i) in acessories_filters" :key="i">
                        <div class="badge_container" @click="selectFilterAcessory(option)">
                            <div class="badge" :class="{ active: selected_acessories_filters.includes(option) }">
                                <span class="badge_title">{{ option }}</span>
                                <div class="badge_info_containers">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-if="selected_acessories_filters.includes(option)" @click.prevent="">
                                        <g clip-path="url(#clip0_7053_117492)">
                                            <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#6C757D"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7053_117492">
                                            <rect width="24" height="24" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="main_table_container">
                    <table class="main_table">
                        <tr>
                            <th class="main_table_title" style="text-align: left; width: 105px; padding-left:16px;">Артикул</th>
                            <th class="main_table_title" style="text-align: left; width: 615px; padding-left:16px;">Найменування</th>
                            <th class="main_table_title" style="width: 105px;">Ціна, грн. <br> без ПДВ</th>
                            <th class="main_table_title" style="width: 129px;">Додати до <br> специфікації</th>
                            <th class="main_table_title" style="width: 134px;">Переглянути <br> клеми</th>
                            <th class="main_table_title" style="width: 78px;">Тех. <br> інфо.</th>
                        </tr>
                        <tr v-for="(acessory, i) in paginatedAccesory()" :key="i">
                            <td class="main_table_row" style="text-align: left; padding-left:16px;padding-right:12px;"><a href="javascript:void(0)" class="article_copy" @click.stop="copyText(acessory.article)" v-tooltip.bottom="'Копіювати артикул'">{{ acessory.article }}</a></td>
                            <td class="main_table_row" style="text-align: left; padding-left:16px;padding-right:12px;">{{ acessory.article }} {{ acessory.name }}</td>
                            <td class="main_table_row" style="text-align: center;">{{ numberWithSpaces( acessory.price/1.2 ) }}</td>
                            <td class="main_table_row" style="text-align: center;">
                                <a href="javascript:void(0)" v-tooltip.bottom="'Додати до специфікації'" @click.prevent="addToSpecificationModal(acessory)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <g clip-path="url(#clip0_7132_41516)">
                                            <path d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7132_41516">
                                            <rect width="24" height="24" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </a>
                            </td>
                            <td class="main_table_row" style="text-align: center;">
                                <a href="#" v-tooltip.bottom="'Переглянути клеми'" @click.prevent="viewKlemasByItem(i, acessory)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none" v-if="selectedAcessories.includes(acessory.article)">
                                        <path d="M12.5 16C13.75 16 14.8125 15.5625 15.6875 14.6875C16.5625 13.8125 17 12.75 17 11.5C17 10.25 16.5625 9.1875 15.6875 8.3125C14.8125 7.4375 13.75 7 12.5 7C11.25 7 10.1875 7.4375 9.3125 8.3125C8.4375 9.1875 8 10.25 8 11.5C8 12.75 8.4375 13.8125 9.3125 14.6875C10.1875 15.5625 11.25 16 12.5 16ZM12.5 14.2C11.75 14.2 11.1125 13.9375 10.5875 13.4125C10.0625 12.8875 9.8 12.25 9.8 11.5C9.8 10.75 10.0625 10.1125 10.5875 9.5875C11.1125 9.0625 11.75 8.8 12.5 8.8C13.25 8.8 13.8875 9.0625 14.4125 9.5875C14.9375 10.1125 15.2 10.75 15.2 11.5C15.2 12.25 14.9375 12.8875 14.4125 13.4125C13.8875 13.9375 13.25 14.2 12.5 14.2ZM12.5 19C10.0667 19 7.85 18.3208 5.85 16.9625C3.85 15.6042 2.4 13.7833 1.5 11.5C2.4 9.21667 3.85 7.39583 5.85 6.0375C7.85 4.67917 10.0667 4 12.5 4C14.9333 4 17.15 4.67917 19.15 6.0375C21.15 7.39583 22.6 9.21667 23.5 11.5C22.6 13.7833 21.15 15.6042 19.15 16.9625C17.15 18.3208 14.9333 19 12.5 19ZM12.5 17C14.3833 17 16.1125 16.5042 17.6875 15.5125C19.2625 14.5208 20.4667 13.1833 21.3 11.5C20.4667 9.81667 19.2625 8.47917 17.6875 7.4875C16.1125 6.49583 14.3833 6 12.5 6C10.6167 6 8.8875 6.49583 7.3125 7.4875C5.7375 8.47917 4.53333 9.81667 3.7 11.5C4.53333 13.1833 5.7375 14.5208 7.3125 15.5125C8.8875 16.5042 10.6167 17 12.5 17Z" fill="#356EEF"/>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-else>
                                        <g clip-path="url(#clip0_7132_41513)">
                                            <path d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z" fill="#AFBBC7"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7132_41513">
                                            <rect width="24" height="24" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </a>
                            </td>
                            <td class="main_table_row" style="text-align: center;">
                                <a href="javascript:void(0)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clip-path="url(#clip0_7132_91719)">
                                        <path d="M11 7.00781H13V9.00781H11V7.00781ZM11 11.0078H13V17.0078H11V11.0078ZM12 2.00781C6.48 2.00781 2 6.48781 2 12.0078C2 17.5278 6.48 22.0078 12 22.0078C17.52 22.0078 22 17.5278 22 12.0078C22 6.48781 17.52 2.00781 12 2.00781ZM12 20.0078C7.59 20.0078 4 16.4178 4 12.0078C4 7.59781 7.59 4.00781 12 4.00781C16.41 4.00781 20 7.59781 20 12.0078C20 16.4178 16.41 20.0078 12 20.0078Z" fill="#356EEF"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_7132_91719">
                                        <rect width="24" height="24" fill="white" transform="translate(0 0.0078125)"/>
                                        </clipPath>
                                    </defs>
                                    </svg>
                                </a>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="table_pagination_container">
                    <div class="table_pagination">
                        <span>Показано</span>
                        <select class="table_pagination_pages" name="select" v-model="sizeAccesory" @change="pageNumberAccesory = 1">
                            <option :value="5">1-5</option>
                            <option :value="10">1-10</option>
                            <option :value="15" selected>1-15</option>
                            <option :value="20" selected>1-20</option>
                        </select>
                        <span>{{ accesoryPageLength() }} з {{ acessories.length }}</span>
                        <div class="pagination_bnts">
                            <a href="javascript:void(0)" class="pagination_bnt" @click="prevPageAccesory()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                                <path d="M7.91016 1.41L3.33016 6L7.91016 10.59L6.50016 12L0.500156 6L6.50016 0L7.91016 1.41Z" fill="black"/>
                                </svg>
                            </a>
                            <a href="javascript:void(0)" class="pagination_bnt" @click="nextPageAccesory()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                                <path d="M0.0898438 1.41L4.66984 6L0.0898438 10.59L1.49984 12L7.49984 6L1.49984 0L0.0898438 1.41Z" fill="black"/>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div id="klemy-m" class="tab_section mobile">
                <div class="tab_section_header">
                    <span class="tab_section_header_item" :class="{active: selectedTab === 1}" @click="selectedTab = 1">Клеми</span>
                    <span class="tab_section_header_item" :class="{active: selectedTab === 2}" @click="selectedTab = 2">Аксесуари</span>
                </div>
                <div class="klemy_tab" v-if="selectedTab === 1">
                    <div class="badge_container" v-if="selected_klemy_filters_count || searchKlemaTitle">
                        <div class="badge">
                            <span class="badge_title">
                                Обрано {{ klemy.length }} клеми
                            </span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" @click.prevent="clearKlemyFilters()">
                                <g clip-path="url(#clip0_7053_106435)">
                                    <path d="M12.6654 4.77398L11.7254 3.83398L7.9987 7.56065L4.27203 3.83398L3.33203 4.77398L7.0587 8.50065L3.33203 12.2273L4.27203 13.1673L7.9987 9.44065L11.7254 13.1673L12.6654 12.2273L8.9387 8.50065L12.6654 4.77398Z" fill="black"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_7053_106435">
                                    <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                    <div class="filter_section">
                        <div class="search_input">
                            <input placeholder="Пошук клем..." v-model="searchKlemaTitle" @input="() => { searchKlemy(); pageNumberKlemy = 1; }">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-if="!searchKlemaTitle || searchKlemaTitle.length < 2">
                                <g clip-path="url(#clip0_7038_110310)">
                                    <path d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z" fill="#356EEF"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_7038_110310">
                                    <rect width="24" height="24" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <svg class="clear_input" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-else @click.prevent="() => { searchKlemaTitle=null; pageNumberKlemy = 1; searchKlemy(); }">
                                <g clip-path="url(#clip0_7077_121330)">
                                    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#B70D09"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_7077_121330">
                                    <rect width="24" height="24" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <a href="javascript:void(0)" class="mobile_filter_ico" @click="modal_klemy_filter=true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <g clip-path="url(#clip0_7336_106472)">
                                    <path d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z" fill="white"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_7336_106472">
                                    <rect width="24" height="24" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <svg class="filter_pointer" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" v-if="selected_klemy_filters_count">
                                <circle cx="7.5" cy="7.5" r="6.5" fill="white" stroke="#356EEF" stroke-width="2"/>
                            </svg>
                        </a>
                    </div>

                    <div class="mobile_acessories_list_item_container mobile">
                        <div class="mobile_acessories_list_item" :class="{active: mobileOpenedKlemas.includes(klema.article)}" v-for="(klema, i) in paginatedKlemy()" :key="i">
                            <div class="mobile_acessories_list_item_header" @click="openMobileOpenedKlemas(klema.article)">
                                <span>{{ klema.article + ' ' + klema.name }}</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clip-path="url(#clip0_7077_121318)">
                                        <path d="M7.41 9.08984L12 13.6698L16.59 9.08984L18 10.4998L12 16.4998L6 10.4998L7.41 9.08984Z" fill="#356EEF"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_7077_121318">
                                        <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div class="mobile_acessories_list_item_content" v-if="mobileOpenedKlemas.includes(klema.article)">
                                <div class="mobile_acessories_list_item_content_row">
                                    <span>Ціна, грн.</span>
                                    <span><b>{{ numberWithSpaces( klema.price/1.2 ) }}</b></span>
                                </div>
                                <div class="mobile_acessories_list_item_content_row" :class="{active: selectedKlemas.includes(klema.article)}">
                                    <span>Переглянути аксесуари</span>
                                    <a href="#" @click.prevent="viewAcessoriesByItem(i, klema)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none" v-if="selectedKlemas.includes(klema.article)">
                                            <path d="M12.5 16C13.75 16 14.8125 15.5625 15.6875 14.6875C16.5625 13.8125 17 12.75 17 11.5C17 10.25 16.5625 9.1875 15.6875 8.3125C14.8125 7.4375 13.75 7 12.5 7C11.25 7 10.1875 7.4375 9.3125 8.3125C8.4375 9.1875 8 10.25 8 11.5C8 12.75 8.4375 13.8125 9.3125 14.6875C10.1875 15.5625 11.25 16 12.5 16ZM12.5 14.2C11.75 14.2 11.1125 13.9375 10.5875 13.4125C10.0625 12.8875 9.8 12.25 9.8 11.5C9.8 10.75 10.0625 10.1125 10.5875 9.5875C11.1125 9.0625 11.75 8.8 12.5 8.8C13.25 8.8 13.8875 9.0625 14.4125 9.5875C14.9375 10.1125 15.2 10.75 15.2 11.5C15.2 12.25 14.9375 12.8875 14.4125 13.4125C13.8875 13.9375 13.25 14.2 12.5 14.2ZM12.5 19C10.0667 19 7.85 18.3208 5.85 16.9625C3.85 15.6042 2.4 13.7833 1.5 11.5C2.4 9.21667 3.85 7.39583 5.85 6.0375C7.85 4.67917 10.0667 4 12.5 4C14.9333 4 17.15 4.67917 19.15 6.0375C21.15 7.39583 22.6 9.21667 23.5 11.5C22.6 13.7833 21.15 15.6042 19.15 16.9625C17.15 18.3208 14.9333 19 12.5 19ZM12.5 17C14.3833 17 16.1125 16.5042 17.6875 15.5125C19.2625 14.5208 20.4667 13.1833 21.3 11.5C20.4667 9.81667 19.2625 8.47917 17.6875 7.4875C16.1125 6.49583 14.3833 6 12.5 6C10.6167 6 8.8875 6.49583 7.3125 7.4875C5.7375 8.47917 4.53333 9.81667 3.7 11.5C4.53333 13.1833 5.7375 14.5208 7.3125 15.5125C8.8875 16.5042 10.6167 17 12.5 17Z" fill="#356EEF"/>
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-else>
                                            <g clip-path="url(#clip0_7132_41513)">
                                                <path d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z" fill="#AFBBC7"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7132_41513">
                                                <rect width="24" height="24" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </a>
                                </div>
                                <div class="mobile_acessories_list_item_content_row">
                                    <span>Додати до специфікації</span>
                                    <a href="javascript:void(0)" @click.prevent="addToSpecificationModal(klema)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <g clip-path="url(#clip0_7132_41516)">
                                                <path d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#356EEF"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7132_41516">
                                                <rect width="24" height="24" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </a>
                                </div>
                                <div class="mobile_acessories_list_item_content_row">
                                    <span>Тех. інфо.</span>
                                    <a :href="klema.technical_characteristics" target="_blank">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <g clip-path="url(#clip0_7132_91719)">
                                            <path d="M11 7.00781H13V9.00781H11V7.00781ZM11 11.0078H13V17.0078H11V11.0078ZM12 2.00781C6.48 2.00781 2 6.48781 2 12.0078C2 17.5278 6.48 22.0078 12 22.0078C17.52 22.0078 22 17.5278 22 12.0078C22 6.48781 17.52 2.00781 12 2.00781ZM12 20.0078C7.59 20.0078 4 16.4178 4 12.0078C4 7.59781 7.59 4.00781 12 4.00781C16.41 4.00781 20 7.59781 20 12.0078C20 16.4178 16.41 20.0078 12 20.0078Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7132_91719">
                                            <rect width="24" height="24" fill="white" transform="translate(0 0.0078125)"/>
                                            </clipPath>
                                        </defs>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="table_pagination_container">
                            <div class="table_pagination">
                                <span>Показано</span>
                                <select class="table_pagination_pages" name="select" v-model="sizeKlemy" @change="pageNumberKlemy = 1">
                                    <option :value="5">1-5</option>
                                    <option :value="10">1-10</option>
                                    <option :value="15" selected>1-15</option>
                                    <option :value="20" selected>1-20</option>
                                </select>
                                <span>{{ klemyPageLength() }} з {{ klemy.length }}</span>
                                <div class="pagination_bnts">
                                    <a href="javascript:void(0)" class="pagination_bnt" @click="prevPage()">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                                        <path d="M7.91016 1.41L3.33016 6L7.91016 10.59L6.50016 12L0.500156 6L6.50016 0L7.91016 1.41Z" fill="black"/>
                                        </svg>
                                    </a>
                                    <a href="javascript:void(0)" class="pagination_bnt" @click="nextPage()">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                                        <path d="M0.0898438 1.41L4.66984 6L0.0898438 10.59L1.49984 12L7.49984 6L1.49984 0L0.0898438 1.41Z" fill="black"/>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="acessory_tab" v-if="selectedTab === 2">
                    <div class="badge_container" v-if="filterAcessoryKlemas.length || selected_acessories_filters.length || searchAcessoryTitle">
                        <div class="badge">
                            <div class="selected_filter_container">
                                <span class="badge_title">
                                    Обрано {{ acessories.length }} аксесуари
                                </span>
                                <span class="filter_klema_title" v-if="selectedFilterKlemaTitle">
                                    {{ selectedFilterKlemaTitle }}
                                </span>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" @click.prevent="clearAcessoryFilters()">
                                <g clip-path="url(#clip0_7053_106435)">
                                    <path d="M12.6654 4.77398L11.7254 3.83398L7.9987 7.56065L4.27203 3.83398L3.33203 4.77398L7.0587 8.50065L3.33203 12.2273L4.27203 13.1673L7.9987 9.44065L11.7254 13.1673L12.6654 12.2273L8.9387 8.50065L12.6654 4.77398Z" fill="black"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_7053_106435">
                                    <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                    <div class="filter_section">
                        <div class="search_input">
                            <input placeholder="Пошук аксесуарів..." v-model="searchAcessoryTitle" @input="() => { searchAccesory(); this.pageNumberAccesory = 1; }">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-if="!searchAcessoryTitle || searchAcessoryTitle.length < 2">
                                <g clip-path="url(#clip0_7038_110310)">
                                    <path d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z" fill="#356EEF"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_7038_110310">
                                    <rect width="24" height="24" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <svg class="clear_input" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-else @click.prevent="() => { searchAcessoryTitle=null; this.pageNumberAccesory = 1; searchAccesory(); }">
                                <g clip-path="url(#clip0_7077_121330)">
                                    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#B70D09"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_7077_121330">
                                    <rect width="24" height="24" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <a href="javascript:void(0)" class="mobile_filter_ico" @click="modal_acessory_filter=true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <g clip-path="url(#clip0_7336_106472)">
                                    <path d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z" fill="white"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_7336_106472">
                                    <rect width="24" height="24" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <svg class="filter_pointer" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" v-if="selected_acessories_filters.length">
                                <circle cx="7.5" cy="7.5" r="6.5" fill="white" stroke="#356EEF" stroke-width="2"/>
                            </svg>
                        </a>
                    </div>

                    <div class="mobile_acessories_list_item_container mobile">
                        <div class="mobile_acessories_list_item" :class="{active: mobileOpenedAcessory.includes(klemaAcessory.article)}" v-for="(klemaAcessory, i) in paginatedAccesory()" :key="i">
                            <div class="mobile_acessories_list_item_header" @click="openMobileOpenedAcessory(klemaAcessory.article)">
                                <span>{{ klemaAcessory.article + ' ' + klemaAcessory.name }}</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clip-path="url(#clip0_7077_121318)">
                                        <path d="M7.41 9.08984L12 13.6698L16.59 9.08984L18 10.4998L12 16.4998L6 10.4998L7.41 9.08984Z" fill="#356EEF"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_7077_121318">
                                        <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div class="mobile_acessories_list_item_content" v-if="mobileOpenedAcessory.includes(klemaAcessory.article)">
                                <div class="mobile_acessories_list_item_content_row">
                                    <span>Ціна, грн.</span>
                                    <span><b>{{ numberWithSpaces( klemaAcessory.price/1.2 ) }}</b></span>
                                </div>
                                <div class="mobile_acessories_list_item_content_row">
                                    <span>Додати до специфікації</span>
                                    <a href="javascript:void(0)" @click.prevent="addToSpecificationModal(klemaAcessory)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <g clip-path="url(#clip0_7132_41516)">
                                                <path d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#356EEF"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7132_41516">
                                                <rect width="24" height="24" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </a>
                                </div>
                                <div class="mobile_acessories_list_item_content_row added" v-if="addedAcessories.includes(klemaAcessory.article)">
                                    <div class="acessory_item_added_container">
                                        <span>Додано до специфікації</span>
                                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="12.5" cy="12" r="12" fill="#54D054"/>
                                            <path d="M18 8.5L11 15.4997L7.5 12" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                </div>
                                
                                <div class="mobile_acessories_list_item_content_row">
                                    <span>Тех. інфо.</span>
                                    <a :href="klemaAcessory.technical_characteristics" target="_blank">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <g clip-path="url(#clip0_7132_91719)">
                                            <path d="M11 7.00781H13V9.00781H11V7.00781ZM11 11.0078H13V17.0078H11V11.0078ZM12 2.00781C6.48 2.00781 2 6.48781 2 12.0078C2 17.5278 6.48 22.0078 12 22.0078C17.52 22.0078 22 17.5278 22 12.0078C22 6.48781 17.52 2.00781 12 2.00781ZM12 20.0078C7.59 20.0078 4 16.4178 4 12.0078C4 7.59781 7.59 4.00781 12 4.00781C16.41 4.00781 20 7.59781 20 12.0078C20 16.4178 16.41 20.0078 12 20.0078Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7132_91719">
                                            <rect width="24" height="24" fill="white" transform="translate(0 0.0078125)"/>
                                            </clipPath>
                                        </defs>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="table_pagination_container">
                            <div class="table_pagination">
                                <span>Показано</span>
                                <select class="table_pagination_pages" name="select" v-model="sizeAccesory" @change="pageNumberAccesory = 1">
                                    <option :value="5">1-5</option>
                                    <option :value="10">1-10</option>
                                    <option :value="15" selected>1-15</option>
                                    <option :value="20" selected>1-20</option>
                                </select>
                                <span>{{ accesoryPageLength() }} з {{ acessories.length }}</span>
                                <div class="pagination_bnts">
                                    <a href="javascript:void(0)" class="pagination_bnt" @click="prevPageAccesory()">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                                        <path d="M7.91016 1.41L3.33016 6L7.91016 10.59L6.50016 12L0.500156 6L6.50016 0L7.91016 1.41Z" fill="black"/>
                                        </svg>
                                    </a>
                                    <a href="javascript:void(0)" class="pagination_bnt" @click="nextPageAccesory()">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                                        <path d="M0.0898438 1.41L4.66984 6L0.0898438 10.59L1.49984 12L7.49984 6L1.49984 0L0.0898438 1.41Z" fill="black"/>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
            <!-- <div class="klema_filters_container">
                <div class="item_filters">
                    <h4 class="klema_filter_title">Підбір клем</h4>
                    <div class="search_input">
                        <input placeholder="Пошук клем..." v-model="searchKlemaTitle" @input="() => { paginatedKlemy(); this.pageNumberKlemy = 1; }">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-if="!searchKlemaTitle || searchKlemaTitle.length < 2">
                            <g clip-path="url(#clip0_7038_110310)">
                                <path d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z" fill="#356EEF"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_7038_110310">
                                <rect width="24" height="24" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                        <svg class="clear_input" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-else @click.prevent="() => { searchKlemaTitle=null; this.pageNumberKlemy = 1; paginatedKlemy(); }">
                            <g clip-path="url(#clip0_7077_121330)">
                                <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#B70D09"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_7077_121330">
                                <rect width="24" height="24" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="klema_filters klemy_filter_items">
                        <div class="klema_item" v-for="(options, title) in klemy_filters" :key="title">
                            <div class="klema_item_dop_header">
                                <h5 class="klema_sub_filter_title">{{ title }}</h5>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" @click.prevent="dropKlemaFilters(title)" v-if="dopKlemaFilters.includes(title)">
                                    <g clip-path="url(#clip0_7132_52434)">
                                        <path d="M7.41 9.08984L12 13.6698L16.59 9.08984L18 10.4998L12 16.4998L6 10.4998L7.41 9.08984Z" fill="#356EEF"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_7132_52434">
                                        <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" @click.prevent="dropKlemaFilters(title)" v-else>
                                    <g clip-path="url(#clip0_7038_110869)">
                                        <path d="M16.59 14.9102L12 10.3302L7.41 14.9102L6 13.5002L12 7.50016L18 13.5002L16.59 14.9102Z" fill="#356EEF"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_7038_110869">
                                        <rect width="24" height="24" fill="white" transform="matrix(1 0 0 -1 0 24)"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <template v-if="!dopKlemaFilters.includes(title)">
                                <div v-for="(option, i) in options" :key="i"
                                    class="badge_select_value"
                                >
                                    <label>
                                        <input class="form_radio" type="checkbox" v-on:change="selectFilterKlemy(title, option)" :value="title+'|'+option" v-model="selected_klemy_filters_checkbox">
                                        <span class="sub_filter_select_title">{{ option }}</span>
                                    </label>
                                </div>
                            </template>
                        </div>
                    </div>

                    <h4 class="acessory_filter_title">Підбір аксесуарів</h4>
                    <div class="search_input">
                        <input placeholder="Пошук аксесуарів..." v-model="searchAcessoryTitle" @input="() => { paginatedAccesory(); this.pageNumberAccesory = 1; }">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-if="!searchAcessoryTitle || searchAcessoryTitle.length < 2">
                            <g clip-path="url(#clip0_7038_110310)">
                                <path d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z" fill="#356EEF"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_7038_110310">
                                <rect width="24" height="24" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                        <svg class="clear_input" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-else @click.prevent="() => { searchAcessoryTitle=null; this.pageNumberAccesory = 1; paginatedKlemy(); }">
                            <g clip-path="url(#clip0_7077_121330)">
                                <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#B70D09"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_7077_121330">
                                <rect width="24" height="24" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="acessory_filters acessory_filter_items">
                        <div class="acessory_item" v-for="(option, i) in acessories_filters" :key="i">
                            <div class="badge_select_value">
                                <label>
                                    <input class="form_radio" type="checkbox" v-on:change="selectFilterAcessory(option)" :value="option" v-model="selected_acessories_filters_checkbox">
                                    <span class="sub_filter_select_title">{{ option }}</span>
                                </label>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="result_items">
                    <div class="klemy filter_section">
                        <div class="filter_section_header">
                            <div class="filter_section_header_title_container">
                                <h4 class="klema_filter_title">Клеми</h4>
                                <div class="badge_container">
                                    <div class="badge" v-if="selected_klemy_filters_count">
                                        <span class="badge_title">
                                            Обрано {{ klemy.length }} клеми
                                        </span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" @click.prevent="clearKlemyFilters()">
                                            <g clip-path="url(#clip0_7053_106435)">
                                                <path d="M12.6654 4.77398L11.7254 3.83398L7.9987 7.56065L4.27203 3.83398L3.33203 4.77398L7.0587 8.50065L3.33203 12.2273L4.27203 13.1673L7.9987 9.44065L11.7254 13.1673L12.6654 12.2273L8.9387 8.50065L12.6654 4.77398Z" fill="black"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7053_106435">
                                                <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <table class="main_table">
                            <tr>
                                <th class="main_table_title" style="text-align: left; width: 615px; padding-left:16px;">Найменування</th>
                                <th class="main_table_title" style="width: 105px;">Ціна, грн. <br> без ПДВ</th>
                                <th class="main_table_title" style="width: 129px;">Додати до <br> специфікації</th>
                                <th class="main_table_title" style="width: 134px;">Переглянути <br> аксесуари</th>
                                <th class="main_table_title" style="width: 78px;">Тех. <br> інфо.</th>
                            </tr>
                            <tr v-for="(klema, i) in paginatedKlemy()" :key="i" :class="{active: selectedKlemas.includes(klema.article)}">
                                <td class="main_table_row" style="text-align: left; padding-left:16px;padding-right:12px;">{{ klema.article + ' ' + klema.name }}</td>
                                <td class="main_table_row" style="text-align: center;">{{ numberWithSpaces( klema.price ) }}</td>
                                <td class="main_table_row" style="text-align: center;">
                                    <a href="javascript:void(0)" v-tooltip.bottom="'Додати до специфікації'" @click.prevent="addToSpecificationModal(klema)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <g clip-path="url(#clip0_7132_41516)">
                                                <path d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#356EEF"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7132_41516">
                                                <rect width="24" height="24" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </a>
                                </td>
                                <td class="main_table_row" style="text-align: center;">
                                    <a href="#" v-tooltip.bottom="'Переглянути аксесуари'" @click.prevent="viewAcessoriesByItem(i, klema)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none" v-if="selectedKlemas.includes(klema.article)">
                                            <path d="M12.5 16C13.75 16 14.8125 15.5625 15.6875 14.6875C16.5625 13.8125 17 12.75 17 11.5C17 10.25 16.5625 9.1875 15.6875 8.3125C14.8125 7.4375 13.75 7 12.5 7C11.25 7 10.1875 7.4375 9.3125 8.3125C8.4375 9.1875 8 10.25 8 11.5C8 12.75 8.4375 13.8125 9.3125 14.6875C10.1875 15.5625 11.25 16 12.5 16ZM12.5 14.2C11.75 14.2 11.1125 13.9375 10.5875 13.4125C10.0625 12.8875 9.8 12.25 9.8 11.5C9.8 10.75 10.0625 10.1125 10.5875 9.5875C11.1125 9.0625 11.75 8.8 12.5 8.8C13.25 8.8 13.8875 9.0625 14.4125 9.5875C14.9375 10.1125 15.2 10.75 15.2 11.5C15.2 12.25 14.9375 12.8875 14.4125 13.4125C13.8875 13.9375 13.25 14.2 12.5 14.2ZM12.5 19C10.0667 19 7.85 18.3208 5.85 16.9625C3.85 15.6042 2.4 13.7833 1.5 11.5C2.4 9.21667 3.85 7.39583 5.85 6.0375C7.85 4.67917 10.0667 4 12.5 4C14.9333 4 17.15 4.67917 19.15 6.0375C21.15 7.39583 22.6 9.21667 23.5 11.5C22.6 13.7833 21.15 15.6042 19.15 16.9625C17.15 18.3208 14.9333 19 12.5 19ZM12.5 17C14.3833 17 16.1125 16.5042 17.6875 15.5125C19.2625 14.5208 20.4667 13.1833 21.3 11.5C20.4667 9.81667 19.2625 8.47917 17.6875 7.4875C16.1125 6.49583 14.3833 6 12.5 6C10.6167 6 8.8875 6.49583 7.3125 7.4875C5.7375 8.47917 4.53333 9.81667 3.7 11.5C4.53333 13.1833 5.7375 14.5208 7.3125 15.5125C8.8875 16.5042 10.6167 17 12.5 17Z" fill="#356EEF"/>
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-else>
                                            <g clip-path="url(#clip0_7132_41513)">
                                                <path d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z" fill="#AFBBC7"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7132_41513">
                                                <rect width="24" height="24" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </a>
                                </td>
                                <td class="main_table_row" style="text-align: center;">
                                    <a :href="klema.technical_characteristics" target="_blank">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <g clip-path="url(#clip0_7132_91719)">
                                            <path d="M11 7.00781H13V9.00781H11V7.00781ZM11 11.0078H13V17.0078H11V11.0078ZM12 2.00781C6.48 2.00781 2 6.48781 2 12.0078C2 17.5278 6.48 22.0078 12 22.0078C17.52 22.0078 22 17.5278 22 12.0078C22 6.48781 17.52 2.00781 12 2.00781ZM12 20.0078C7.59 20.0078 4 16.4178 4 12.0078C4 7.59781 7.59 4.00781 12 4.00781C16.41 4.00781 20 7.59781 20 12.0078C20 16.4178 16.41 20.0078 12 20.0078Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7132_91719">
                                            <rect width="24" height="24" fill="white" transform="translate(0 0.0078125)"/>
                                            </clipPath>
                                        </defs>
                                        </svg>
                                    </a>
                                </td>
                            </tr>
                        </table>
                        <div class="table_pagination_container">
                            <div class="table_pagination">
                                <span>Показано</span>
                                <select class="table_pagination_pages" name="select" v-model="sizeKlemy" @change="pageNumberKlemy = 1">
                                    <option :value="5">1-5</option>
                                    <option :value="10">1-10</option>
                                    <option :value="15" selected>1-15</option>
                                    <option :value="20" selected>1-20</option>
                                </select>
                                <span>{{ klemyPageLength() }} з {{ klemy.length }}</span>
                                <div class="pagination_bnts">
                                    <a href="javascript:void(0)" class="pagination_bnt" @click="prevPage()">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                                        <path d="M7.91016 1.41L3.33016 6L7.91016 10.59L6.50016 12L0.500156 6L6.50016 0L7.91016 1.41Z" fill="black"/>
                                        </svg>
                                    </a>
                                    <a href="javascript:void(0)" class="pagination_bnt" @click="nextPage()">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                                        <path d="M0.0898438 1.41L4.66984 6L0.0898438 10.59L1.49984 12L7.49984 6L1.49984 0L0.0898438 1.41Z" fill="black"/>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="acessories filter_section">
                        <div class="filter_section_header">
                            <div class="filter_section_header_title_container">
                                <h4 class="acessory_filter_title2">Аксесуари</h4>
                                <div class="badge_container">
                                    <div class="badge" v-if="filterAcessoryKlemas.length || selected_acessories_filters.length">
                                        <span class="badge_title">
                                            Обрано {{ acessories.length }} аксесуари
                                        </span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" @click.prevent="clearAcessoryFilters()">
                                            <g clip-path="url(#clip0_7053_106435)">
                                                <path d="M12.6654 4.77398L11.7254 3.83398L7.9987 7.56065L4.27203 3.83398L3.33203 4.77398L7.0587 8.50065L3.33203 12.2273L4.27203 13.1673L7.9987 9.44065L11.7254 13.1673L12.6654 12.2273L8.9387 8.50065L12.6654 4.77398Z" fill="black"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7053_106435">
                                                <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <table class="main_table">
                            <tr>
                                <th class="main_table_title" style="text-align: left; width: 615px; padding-left:16px;">Найменування</th>
                                <th class="main_table_title" style="width: 105px;">Ціна, грн. <br> без ПДВ</th>
                                <th class="main_table_title" style="width: 129px;">Додати до <br> специфікації</th>
                                <th class="main_table_title" style="width: 78px;">Тех. <br> інфо.</th>
                            </tr>
                            <tr v-for="(acessory, i) in paginatedAccesory()" :key="i">
                                <td class="main_table_row" style="text-align: left; padding-left:16px;padding-right:12px;">{{ acessory.article + ' ' + acessory.name }}</td>
                                <td class="main_table_row" style="text-align: center;">{{ numberWithSpaces( acessory.price ) }}</td>
                                <td class="main_table_row" style="text-align: center;">
                                    <a href="javascript:void(0)" v-tooltip.bottom="'Додати до специфікації'" @click.prevent="addToSpecificationModal(acessory)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <g clip-path="url(#clip0_7132_41516)">
                                                <path d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#356EEF"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7132_41516">
                                                <rect width="24" height="24" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </a>
                                </td>
                                <td class="main_table_row" style="text-align: center;">
                                    <a href="javascript:void(0)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <g clip-path="url(#clip0_7132_91719)">
                                            <path d="M11 7.00781H13V9.00781H11V7.00781ZM11 11.0078H13V17.0078H11V11.0078ZM12 2.00781C6.48 2.00781 2 6.48781 2 12.0078C2 17.5278 6.48 22.0078 12 22.0078C17.52 22.0078 22 17.5278 22 12.0078C22 6.48781 17.52 2.00781 12 2.00781ZM12 20.0078C7.59 20.0078 4 16.4178 4 12.0078C4 7.59781 7.59 4.00781 12 4.00781C16.41 4.00781 20 7.59781 20 12.0078C20 16.4178 16.41 20.0078 12 20.0078Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7132_91719">
                                            <rect width="24" height="24" fill="white" transform="translate(0 0.0078125)"/>
                                            </clipPath>
                                        </defs>
                                        </svg>
                                    </a>
                                </td>
                            </tr>
                        </table>
                        <div class="table_pagination_container">
                            <div class="table_pagination">
                                <span>Показано</span>
                                <select class="table_pagination_pages" name="select" v-model="sizeAccesory" @change="pageNumberAccesory = 1">
                                    <option :value="5">1-5</option>
                                    <option :value="10">1-10</option>
                                    <option :value="15" selected>1-15</option>
                                    <option :value="20" selected>1-20</option>
                                </select>
                                <span>{{ accesoryPageLength() }} з {{ acessories.length }}</span>
                                <div class="pagination_bnts">
                                    <a href="javascript:void(0)" class="pagination_bnt" @click="prevPageAccesory()">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                                        <path d="M7.91016 1.41L3.33016 6L7.91016 10.59L6.50016 12L0.500156 6L6.50016 0L7.91016 1.41Z" fill="black"/>
                                        </svg>
                                    </a>
                                    <a href="javascript:void(0)" class="pagination_bnt" @click="nextPageAccesory()">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                                        <path d="M0.0898438 1.41L4.66984 6L0.0898438 10.59L1.49984 12L7.49984 6L1.49984 0L0.0898438 1.41Z" fill="black"/>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>


        <div class="overlay" v-if="modal_info || modal_docs || modal_total || modal_confirm || modal_add_to_items || modal_klemy_filter || modal_acessory_filter" v-on:click="() => {modal_info = false; modal_docs = false; modal_total = false; summarize = false; modal_confirm = false; modal_add_to_items = false; modal_klemy_filter = false; modal_acessory_filter = false; }"></div>
        <div class="modal description_modal" v-if="modal_info">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">Опис роботи сервісу</p>
                    <svg id="close_modal" v-on:click="modal_info = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_content" v-html="text"></div>
            </div>
        </div>
        <div class="modal description_modal" v-if="modal_confirm">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">Ви хочете видалити <span v-if="confirmItem.is_din">або замінити</span></p>
                    <svg id="close_modal" v-on:click="modal_confirm = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_confirm_content">{{ modal_confirm_text }}</div>
                <div class="confirm_buttons">
                    <a href="#" class="confirm_button_confirm" @click.prevent="cancel()" v-if="!confirmItem.is_din">Відмінити</a>
                    <a href="#" class="confirm_button_confirm" @click.prevent="change()" v-else>Замінити</a>
                    <a href="#" class="confirm_button_cancel" @click.prevent="confirm()">Видалити</a>
                </div>
            </div>
        </div>
        <div class="modal description_modal" v-if="modal_add_to_items">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">Додати в специфікацію</p>
                    <svg id="close_modal" v-on:click="modal_add_to_items = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_confirm_content">{{ add_item.item.name }}</div>
                <div class="count_container">
                    <label>Кількість, {{ add_item.item.name.includes('пластина') ? 'пластин' : 'шт.'}}</label>
                    <input v-model="add_item.item.count" @input="filterAddItemPositiveCount()" class="main_table_count_input" type="number" min="1">
                </div>
                <div class="klema_ryad_select_container">
                    <label><b>Клемний ряд</b></label>
                    <select v-model="add_item.key" class="form_select">
                        <option :value="null" disabled>Виберіть клемний ряд</option>
                        <option v-for="(klema, k) in klemyRows" :key="k" :value="k">{{ klema.name }}</option>
                    </select>
                </div>
                <div class="confirm_buttons">
                    <a href="#" class="confirm_button_cancel" @click.prevent="addToSpecification()">Ок</a>
                    <a href="#" class="confirm_button_confirm" @click.prevent="modal_add_to_items=false">Відмінити</a>
                </div>
            </div>
        </div>
        <div class="modal filter_modal" v-if="modal_klemy_filter">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">Фільтри</p>
                    <svg id="close_modal" v-on:click="modal_klemy_filter = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="options_container">
                    <div class="klema_item" v-for="(options, title) in klemy_filters" :key="title">
                        <div class="klema_item_dop_header" @click.prevent="dropKlemaFilters(title)" :class="{active: dopKlemaFilters.includes(title)}">
                            <h5 class="klema_sub_filter_title">{{ title }}</h5>
                            <div class="selected_filter_count" v-if="selected_klemy_filters[title] && selected_klemy_filters[title].length">{{ selected_klemy_filters[title].length }} фільтри обрано</div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-if="!dopKlemaFilters.includes(title)">
                                <g clip-path="url(#clip0_7132_52434)">
                                    <path d="M7.41 9.08984L12 13.6698L16.59 9.08984L18 10.4998L12 16.4998L6 10.4998L7.41 9.08984Z" fill="#356EEF"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_7132_52434">
                                    <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-else>
                                <g clip-path="url(#clip0_7038_110869)">
                                    <path d="M16.59 14.9102L12 10.3302L7.41 14.9102L6 13.5002L12 7.50016L18 13.5002L16.59 14.9102Z" fill="#356EEF"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_7038_110869">
                                    <rect width="24" height="24" fill="white" transform="matrix(1 0 0 -1 0 24)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <template v-if="dopKlemaFilters.includes(title)">
                            <div class="clear_klema_filters" v-if="selected_klemy_filters[title] && selected_klemy_filters[title].length">
                                <a href="javascript:void(0)" class="clear_klema_filter" @click="clearCustomKlemaFilter(title)">
                                    <span>Скинути</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <g clip-path="url(#clip0_7317_107479)">
                                            <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7317_107479">
                                            <rect width="24" height="24" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </a>
                            </div>

                            <div v-for="(option, i) in options" :key="i"
                                class="badge_select_value"
                            >
                                <label>
                                    <input class="form_radio" type="checkbox" v-on:change="selectFilterKlemy(title, option)" :value="title+'|'+option" v-model="selected_klemy_filters_checkbox">
                                    <span class="sub_filter_select_title">{{ option }}</span>
                                </label>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="confirm_buttons">
                    <a href="javascript:void(0)" class="confirm_button_confirm" @click="clearKlemyFilters()">Скинути всі</a>
                    <a href="javascript:void(0)" class="confirm_button_cancel" @click.prevent="filterData()">Застосувати</a>
                </div>
            </div>
        </div>
        <div class="modal filter_modal" v-if="modal_acessory_filter">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">Фільтри</p>
                    <svg id="close_modal" v-on:click="modal_acessory_filter = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="options_container">
                    <div class="acessory_item acessory_item_modal" v-for="(option, i) in acessories_filters" :key="i">
                        <div class="badge_select_value">
                            <label>
                                <input class="form_radio" type="checkbox" :value="option" v-model="selected_acessories_filters_checkbox">
                                <span class="sub_filter_select_title">{{ option }}</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="confirm_buttons">
                    <a href="javascript:void(0)" class="confirm_button_confirm" @click="clearAcessoryFilters()">Скинути всі</a>
                    <a href="javascript:void(0)" class="confirm_button_cancel" @click.prevent="modalFilterAcessory()">Застосувати</a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import PreloadForm from "@/Components/PreloadForm";
import Fieldset from 'primevue/fieldset';
import Dropdown from 'primevue/dropdown';
import RadioButton from 'primevue/radiobutton';
import InputNumber from 'primevue/inputnumber';
import Checkbox from 'primevue/checkbox';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Row from "primevue/row";
import axios from "axios";
import CommonLayout from "@/Layouts/CommonLayout";
import Label from '../Jetstream/Label.vue';
import Input from '../Jetstream/Input.vue';
import Tooltip from 'primevue/tooltip';
import CustomMultiselect from "../Components/CustomMultiselect.vue";
import { nextTick } from 'vue'
import ProgressSpinner from 'primevue/progressspinner';

export default {
    directives: {
        Tooltip,
    },
    props: {
        text: {
            type: String,
            required: false,
        }
    },

    components: {
        PreloadForm,
        Fieldset,
        Dropdown,
        RadioButton,
        InputNumber,
        Checkbox,
        TabView,
        TabPanel,
        DataTable,
        Column,
        Button,
        Dialog,
        ColumnGroup,
        Row,
        Input,
        Label,
        CustomMultiselect,
        ProgressSpinner,
    },
    layout: CommonLayout,
    data() {
        return {
            modal_info: false,
            modal_docs: false,
            modal_total: false,

            modal_confirm: false,
            modal_confirm_text: 'Ви хочете видалити',

            modal_add_to_items: false,

            modal_klemy_filter: false,
            modal_acessory_filter: false,

            add_item: {
                item: null,
                key: null,
            },

            payload: false,
            error: false,

            klemyRows: [
                {
                    name: 'Клемний ряд 1',
                    oldName: 'Клемний ряд 1',
                    length: 0,
                    editTitle: false,
                    acessories: [],
                }
            ],

            addedAcessories: [],

            project: {
                name: 'Введіть назву проекту',
                oldName: 'Введіть назву проекту',
                editTitle: false,
            },

            selectedTab: 1,

            summarizeResult: [],

            openedSections: [0],

            klemy: [],
            acessories: [],

            klemyOld: [],
            acessoriesOld: [],

            klemy_filters: [],
            acessories_filters: [],

            selected_klemy_filters: {},
            selected_klemy_filters_count: 0,
            selected_acessories_filters: [],

            selected_klemy_filters_checkbox: [],
            selected_acessories_filters_checkbox: [],

            mobileOpenedAcessories: [],
            mobileOpenedKlemas: [],
            mobileOpenedAcessory: [],

            pageNumberKlemy: 1,
            sizeKlemy: 10,

            pageNumberAccesory: 1,
            sizeAccesory: 10,

            itemOnDelete: null,

            summarize: false,

            searchKlemaTitle: null,
            searchAcessoryTitle: null,

            confirmItem: {
                item: null,
                key: null,
                item_key: null,
                is_din: false,
            },

            defaultDin: null,

            selectedKlemas: [],
            selectedAcessories: [],
            filterAcessoryKlemas: [],

            dopKlemaFilters: [],

            filterDrop: null,

            selectedFilterKlemaTitle: null,

            is_drop_commercial_offer: false,
            commercial_offer_sended: false,
            is_disable_commercial_offer_btn: false,
            commercial_offer_id: null,
            commercial_offer_created_at: null,
            commercialOfferData: {
                organization: null,
                name: null,
                phone: null,
                email: null,
                comment: null,
            },
            commercialOfferDataErrors: {
                phone: null,
                email: null,
            },
        }
    },

    mounted() {
        this.getData();

        window.addEventListener('click', this.outsideClick);
    },

    destroyed() {
        window.removeEventListener('click', this.outsideClick);
    },

    methods: {
        filterAddItemPositiveCount(i) {
            if (this.add_item.item.count && this.add_item.item.count < 1) {
                this.add_item.item.count = 1;
            }
        },
        filterKlemaPositiveCountSumm(i) {
            if (this.summarizeResult[i].count && this.summarizeResult[i].count < 1) {
                this.summarizeResult[i].count = 1;
            }
        },
        filterKlemaPositiveCount(k, i) {
            if (this.klemyRows[k].acessories[i].count && this.klemyRows[k].acessories[i].count < 1) {
                this.klemyRows[k].acessories[i].count = 1;
            }
        },

        outsideClick(event) {
            let elClass = event.target.getAttribute("class")

            if (
                elClass &&
                elClass !== 'filter_select_badges' &&
                elClass !== 'badge_title' &&
                elClass !== 'badge_select' &&
                elClass !== 'badge_select open'
            ) {
                this.filterDrop = null
            }
        },

        closeFilters(title){
            this.filterDrop = title
        },

        isMobile() {
            return window.innerWidth <= 960;
        },

        openMobileAcessories(key) {
            if (this.mobileOpenedAcessories.includes(key)) {
                let index = this.mobileOpenedAcessories.indexOf(key);
                if (index !== -1) {
                    this.mobileOpenedAcessories.splice(index, 1);
                }
            } else {
                this.mobileOpenedAcessories.push(key)
            }
        },

        openMobileOpenedKlemas(key) {
            if (this.mobileOpenedKlemas.includes(key)) {
                let index = this.mobileOpenedKlemas.indexOf(key);
                if (index !== -1) {
                    this.mobileOpenedKlemas.splice(index, 1);
                }
            } else {
                this.mobileOpenedKlemas.push(key)
            }
        },

        openMobileOpenedAcessory(key) {
            if (this.mobileOpenedAcessory.includes(key)) {
                let index = this.mobileOpenedAcessory.indexOf(key);
                if (index !== -1) {
                    this.mobileOpenedAcessory.splice(index, 1);
                }
            } else {
                this.mobileOpenedAcessory.push(key)
            }
        },

        dropKlemaFilters(key) {
            if (this.dopKlemaFilters.includes(key)) {
                let index = this.dopKlemaFilters.indexOf(key);
                if (index !== -1) {
                    this.dopKlemaFilters.splice(index, 1);
                }
            } else {
                this.dopKlemaFilters.push(key)
            }
        },

        scrollTop(id) {
            const el = document.getElementById(id);

            if (el) {
                el.scrollIntoView({behavior: "smooth"});
            }
        },

        numberWithSpaces(x) {
            x = parseFloat(x);
            x = x.toFixed(2);
            var parts = x.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return parts.join(",");
        },

        getTotalWidth(items) {
            let totalW = 0
            if (items.length) {
                items.forEach((value, index) => {
                    if (value && value.width) {
                        totalW += parseFloat(value.width) * (value.count ? value.count : 1)
                    }
                });
            }

            return this.numberWithSpaces(totalW);
        },

        totalSumm() {
            let summ = 0;
            
            if (this.summarize) {
                this.summarizeResult.forEach((value, index) => {
                    let itemSumm = value.count * (value.price/1.2);
                    summ += itemSumm;
                    value.summ = itemSumm;
                });
            } else {
                this.klemyRows.forEach((value, index) => {
                    value.acessories.forEach((value, index) => {
                        let itemSumm = value.count * (value.price/1.2);
                        summ += itemSumm;
                        value.summ = itemSumm;
                    });
                });
            }

            return this.numberWithSpaces(summ);
        },
        pdv() {
            let summ = 0;
            let pdv = 0;

            if (this.summarize) {
                this.summarizeResult.forEach((value, index) => {
                    let itemSumm = value.count * (value.price/1.2);
                    summ += itemSumm;
                    value.summ = itemSumm;
                });
            } else {
                this.klemyRows.forEach((value, index) => {
                    value.acessories.forEach((value, index) => {
                        let itemSumm = value.count * (value.price/1.2);
                        summ += itemSumm;
                        value.summ = itemSumm;
                    });
                });
            }

            pdv = (summ * 20) / 100;

            return this.numberWithSpaces(pdv);
        },
        summPdv() {
            let summ = 0;
            let pdv = 0;

            if (this.summarize) {
                this.summarizeResult.forEach((value, index) => {
                    let itemSumm = value.count * (value.price/1.2);
                    summ += itemSumm;
                    value.summ = itemSumm;
                });
            } else {
                this.klemyRows.forEach((value, index) => {
                    value.acessories.forEach((value, index) => {
                        let itemSumm = value.count * (value.price/1.2);
                        summ += itemSumm;
                        value.summ = itemSumm;
                    });
                });
            }

            pdv = (summ * 20) / 100;

            return this.numberWithSpaces(summ + pdv);
        },

        getExcel() {
            axios.post(this.route('api.klemny_riad_get_excel'), {
                items: this.summarize ? this.summarizeResult : this.klemyRows,
                summarize: this.summarize,
                project: this.project.name,
            })
            .then((response) => {
                var fileURL = response.data.data;
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', response.data.name);
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
            })
        },

        doSummarize() {
            this.summarize = !this.summarize;
            this.summarizeResult = [];
            let articles = [];

            let items = _.cloneDeep(this.klemyRows)

            let preSumm = [];

            items.forEach((item, index) => {
                item.acessories.forEach((product, key) => {
                    preSumm.push(product);
                });
            });

            // let preItem = null
            // preSumm.forEach((v, index) => {
            //     if (!articles.includes(v.article)) {
            //         articles.push(v.article);
            //         preItem = v
            //     } else {
            //         let summ = 0
            //         preSumm.forEach((preSummItem) => {
            //             if (preSummItem.article === v.article) {
            //                 summ += parseInt(preSummItem.count)
            //             }
            //         });

            //         if (preItem) {
            //             preItem.count = summ

            //             this.summarizeResult.push(preItem);

            //             preItem = null
            //         }
            //     }
            // });

            axios.post(this.route('api.klemny_riad_get_grouped'), {
                items: preSumm,
            })
            .then((response) => {
                this.summarizeResult = response.data.data;
            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
            })

            this.$forceUpdate();
        },

        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return '0 Bytes'

            const k = 1024
            const dm = decimals < 0 ? 0 : decimals
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

            const i = Math.floor(Math.log(bytes) / Math.log(k))

            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
        },

        addToSpecificationModal(item) {
            this.modal_add_to_items = true
            this.add_item.item = item
            
            if (this.klemyRows.length === 1) {
                this.add_item.key = 0
            } else {
                this.add_item.key = null
            }
        },
        
        async addToSpecification() {
            this.summarize = false
            this.klemyRows[this.add_item.key].acessories.push(this.add_item.item)
            this.modal_add_to_items = false

            this.addedAcessories.push(this.add_item.item.article)

            await nextTick()

            if (this.confirmItem.is_din) {
                this.confirmItem.is_din = false
                this.selected_acessories_filters = []
            }

            this.add_item.item = null
            this.add_item.key = null

            this.scrollTop('items')
        },

        selectFilterKlemy(key, option) {
            if (option) {
                if (!this.selected_klemy_filters[key]) {
                    this.selected_klemy_filters[key] = [];
                }

                if (this.selected_klemy_filters[key].includes(option)) {
                    let index = this.selected_klemy_filters[key].indexOf(option);
                    if (index !== -1) {
                        this.selected_klemy_filters[key].splice(index, 1);
                    }
                    
                    if (this.selected_klemy_filters_count > 1) {
                        this.selected_klemy_filters_count--;
                    }
                } else {
                    this.selected_klemy_filters[key].push(option)
                    this.selected_klemy_filters_count++;
                }
            }

            this.filterData()

            this.$forceUpdate();
        },

        viewAcessoriesByItem(i, klema) {
            if (this.selectedKlemas.includes(klema.article)) {
                let index = this.selectedKlemas.indexOf(klema.article);
                if (index !== -1) {
                    this.selectedKlemas.splice(index, 1);
                }

                let index2 = this.filterAcessoryKlemas.indexOf(klema.article);
                if (index2 !== -1) {
                    this.filterAcessoryKlemas.splice(index2, 1);
                }

                this.selectedFilterKlemaTitle = null
            } else {
                this.selectedKlemas = []
                this.filterAcessoryKlemas = []

                this.selectedKlemas.push(klema.article)

                this.filterAcessoryKlemas.push(klema.article)

                this.selectedFilterKlemaTitle = klema.name

                this.scrollTop('acessories')
            }

            this.payload = true;
            this.error = false;
            this.selected_acessories_filters = []
            this.selected_acessories_filters_checkbox = []
            axios.post(this.route('api.klemnyi_riad_data'), {
                selected_klemy_filters: this.selected_klemy_filters,
                filter_acessory_klemas: this.filterAcessoryKlemas,
            })
                .then((result) => {
                    this.acessories = result.data.acessories
                    this.acessories_filters = result.data.acessories_filters

                    this.selectedTab = 2

                    this.payload = false;
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })
        },

        viewKlemasByItem(i, accessory) {
            if (this.selectedAcessories.includes(accessory.article)) {
                let index = this.selectedAcessories.indexOf(accessory.article);
                if (index !== -1) {
                    this.selectedAcessories.splice(index, 1);
                }

            } else {
                this.selectedAcessories.push(accessory.article)

                this.scrollTop('klemy')
            }

            this.payload = true;
            this.error = false;
            this.selected_klemy_filters = []
            this.selected_klemy_filters_checkbox = []
            this.filterAcessoryKlemas = []
            this.selectedFilterKlemaTitle = null
            axios.post(this.route('api.klemnyi_riad_data.klemy'), {
                accessory: this.selectedAcessories,
            })
                .then((result) => {
                    this.klemy = result.data.klemy
                    this.klemyOld = result.data.klemy
                    this.selected_klemy_filters_count = this.klemy.length
                    this.klemy_filters = result.data.klemy_filters

                    this.selectedTab = 1

                    this.payload = false;
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })
        },

        selectFilterAcessory(option = null) {
            if (option) {
                if (this.selected_acessories_filters.includes(option)) {
                    let index = this.selected_acessories_filters.indexOf(option);
                    if (index !== -1) {
                        this.selected_acessories_filters.splice(index, 1);
                    }
                } else {
                    this.selected_acessories_filters.push(option)
                }
            }

            this.filterData();

            this.$forceUpdate();
        },

        modalFilterAcessory() {
            this.selected_acessories_filters = _.cloneDeep(this.selected_acessories_filters_checkbox)

            this.modal_acessory_filter = false;

            this.filterData();

            this.$forceUpdate();
        },

        clearKlemyFilters() {
            this.selected_klemy_filters = {};
            this.selected_klemy_filters_count = 0;
            this.searchKlemaTitle = null;

            this.selectedAcessories = [];

            this.dopKlemaFilters = [];

            this.selected_klemy_filters_checkbox = [];

            this.modal_klemy_filter = false;

            this.filterData();
            
            this.$forceUpdate();
        },

        clearCustomKlemaFilter(title) {
            this.selected_klemy_filters_count = this.selected_klemy_filters_count - this.selected_klemy_filters[title].length
            this.selected_klemy_filters[title] = [];

            this.selectedAcessories = [];

            this.selected_klemy_filters_checkbox = this.selected_klemy_filters_checkbox.filter(e => !e.includes(title))

            this.$forceUpdate();
        },

        clearAcessoryFilters() {
            this.selected_acessories_filters = [];
            this.filterAcessoryKlemas = [];
            this.selectedKlemas = [];
            this.searchAcessoryTitle = null;

            this.modal_acessory_filter = false;

            this.selectedFilterKlemaTitle = null;

            this.selected_acessories_filters_checkbox = [];

            this.payload = true;
            this.error = false;
            axios.post(this.route('api.klemnyi_riad_data'), {
                selected_klemy_filters: this.selected_klemy_filters,
                filter_acessory_klemas: this.filterAcessoryKlemas,
            })
                .then((result) => {
                    this.acessories = result.data.acessories
                    this.acessories_filters = result.data.acessories_filters

                    this.payload = false;
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })
        },

        deleteAccesoryItem(k, i, acessory) {
            this.modal_confirm = true;
            this.confirmItem.item = acessory
            this.confirmItem.key = k
            this.confirmItem.item_key = i

            if (acessory.acessory_type && acessory.acessory_type === 'DIN-рейки та кінцеві стопори') {
                this.confirmItem.is_din = true
            }

            this.modal_confirm_text = acessory.name  + '?';
            // this.klemyRows[k].acessories.splice(i, 1);
        },

        confirm() {
            this.klemyRows[this.confirmItem.key].acessories.splice(this.confirmItem.item_key, 1);

            this.modal_confirm = false;
            this.confirmItem.item = null
            this.confirmItem.key = null
            this.confirmItem.item_key = null
            this.confirmItem.is_din = false
        },
        cancel() {
            this.modal_confirm = false;
            this.confirmItem.item = null
            this.confirmItem.key = null
            this.confirmItem.item_key = null
            this.confirmItem.is_din = false
        },
        async change() {
            this.selectedTab = 2;

            this.selectFilterAcessory('DIN-рейки та кінцеві стопори')

            this.klemyRows[this.confirmItem.key].acessories.splice(this.confirmItem.item_key, 1);

            this.modal_confirm = false;
            this.confirmItem.item = null
            this.confirmItem.key = null
            this.confirmItem.item_key = null

            await nextTick()

            this.scrollTop('acessories')
            this.scrollTop('klemy-m')
        },

        getData() {
            this.payload = true;
            this.error = false;
            axios.post(this.route('api.klemnyi_riad_data'))
                .then((result) => {
                    this.klemy = result.data.klemy
                    this.acessories = result.data.acessories
                    this.klemyOld = result.data.klemy
                    this.acessoriesOld = result.data.acessories
                    this.klemy_filters = result.data.klemy_filters
                    this.acessories_filters = result.data.acessories_filters
                    this.defaultDin = result.data.startDinRail

                    if (result.data.startDinRail) {
                        this.klemyRows[0].acessories.push(result.data.startDinRail)
                    }

                    this.payload = false;
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })
        },

        filterData() {
            this.pageNumberKlemy = 1;
            this.pageNumberAccesory = 1;

            this.modal_klemy_filter = false;

            this.payload = true;
            this.error = false;
            axios.post(this.route('api.klemnyi_riad_data'), {
                accessory: this.selectedAcessories,
                selected_klemy_filters: this.selected_klemy_filters,
                selected_acessories_filters: this.selected_acessories_filters,
                filter_acessory_klemas: this.filterAcessoryKlemas,
            })
                .then((result) => {
                    this.klemy = result.data.klemy
                    this.acessories = result.data.acessories
                    this.klemyOld = result.data.klemy
                    this.acessoriesOld = result.data.acessories

                    this.searchKlemy()
                    this.searchAccesory()

                    this.payload = false;
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })
        },

        nextPage(){
            if (this.pageNumberKlemy < this.pageCount()) {
                this.pageNumberKlemy++;
            }
        },
        prevPage(){
            if (this.pageNumberKlemy > 1) {
                this.pageNumberKlemy--;
            }
        },
        pageCount(){
            let l = this.klemy.length,
                s = this.sizeKlemy;
            return Math.ceil(l/s);
        },
        klemyPageLength() {
            let countOnPage = this.pageNumberKlemy * this.sizeKlemy

            if (this.pageNumberKlemy == this.pageCount()) {
                let last = this.klemy.length - (this.pageNumberKlemy * this.sizeKlemy)
                countOnPage = countOnPage + last
            }
            return countOnPage
        },
        paginatedKlemy(){
            let items = _.cloneDeep(this.klemy)

            if (items.length > this.sizeKlemy) {
                const start = this.pageNumberKlemy > 1 ? (this.pageNumberKlemy * this.sizeKlemy)-this.sizeKlemy : 0
                const end = start + this.sizeKlemy;
                return items.slice(start, end);
            } else {
                return items;
            }
        },

        searchKlemy(){
            let items = _.cloneDeep(this.klemyOld)

            if (this.searchKlemaTitle && this.searchKlemaTitle !== '' && this.searchKlemaTitle !== undefined && this.searchKlemaTitle.length > 2) {
                const needle = this.searchKlemaTitle.toLowerCase().replace(/\./g, '')

                let result = []

                items.forEach((item) => {
                    let name = item.article.replace(/\./g, '').toLowerCase() + ' ' + item.name.replace(/\./g, '').toLowerCase()
                    if (name.includes(needle)) {
                        result.push(item)
                    }
                })

                this.klemy = result
            } else {
                this.klemy = items
            }
        },

        nextPageAccesory(){
            if (this.pageNumberAccesory < this.pageCountAccesory()) {
                this.pageNumberAccesory++;
            }
        },
        prevPageAccesory(){
            if (this.pageNumberAccesory > 1) {
                this.pageNumberAccesory--;
            }
        },
        pageCountAccesory(){
            let l = this.acessories.length,
                s = this.sizeAccesory;
            return Math.ceil(l/s);
        },

        accesoryPageLength() {
            let countOnPage = this.pageNumberAccesory * this.sizeAccesory

            if (this.pageNumberAccesory == this.pageCountAccesory()) {
                let last = this.acessories.length - (this.pageNumberAccesory * this.sizeAccesory)
                countOnPage = countOnPage + last
            }
            return countOnPage
        },

        paginatedAccesory(){
            let items = _.cloneDeep(this.acessories)

            if (items.length > this.sizeAccesory) {
                const start = this.pageNumberAccesory > 1 ? (this.pageNumberAccesory * this.sizeAccesory)-this.sizeAccesory : 0
                
                const end = start + this.sizeAccesory;

                return items.slice(start, end);
            } else {
                return items;
            }
        },
        searchAccesory(){
            let items = _.cloneDeep(this.acessoriesOld)

            if (this.searchAcessoryTitle && this.searchAcessoryTitle !== '' && this.searchAcessoryTitle !== undefined && this.searchAcessoryTitle.length > 2) {
                const needle = this.searchAcessoryTitle.toLowerCase().replace(/\./g, '')

                let result = []

                items.forEach((item) => {
                    let name = item.article.replace(/\./g, '').toLowerCase() + ' ' + item.name.replace(/\./g, '').toLowerCase()
                    if (name.includes(needle)) {
                        result.push(item)
                    }
                })

                this.acessories = result
            } else {
                this.acessories = items
            }
        },

        openSection(i) {
            if (this.openedSections.includes(i)) {
                let index = this.openedSections.indexOf(i);
                if (index !== -1) {
                    this.openedSections.splice(index, 1);
                }
            } else {
                this.openedSections.push(i)
            }
        },

        async addItemAcessory(key = 0) {
            this.add_item.key = key

            await nextTick()

            this.scrollTop('klemy')
            this.scrollTop('klemy-m')
        },

        addItem() {
            let acessories = []
            if (this.defaultDin) {
                let defaultDin = _.cloneDeep(this.defaultDin)

                defaultDin.count = 1

                acessories = [defaultDin]
            }

            this.klemyRows.push({
                name: 'Клемний ряд ' + (this.klemyRows.length + 1),
                oldName: 'Клемний ряд ' + (this.klemyRows.length + 1),
                length: 0,
                editTitle: false,
                acessories: acessories,
            })

            this.openedSections.push(this.klemyRows.length - 1)

            this.$forceUpdate();
        },
        copyItem(index) {
            let item = _.cloneDeep( this.klemyRows[index] );

            this.klemyRows.splice(index, 0, item);
        },
        copyText(text) {
            navigator.clipboard.writeText(text);

            // alert('Артикул скопійовано')
        },
        deleteItem(index) {
            if (this.klemyRows.length > 1) {
                this.klemyRows.splice(index, 1);
            }
        },

        dropCommercialOfferForm() {
            this.is_drop_commercial_offer = !this.is_drop_commercial_offer
        },
        acceptNumber() {
            var x = this.commercialOfferData.phone.replace(/\D/g, '').replace('380', '').replace('38', '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/);

            this.commercialOfferData.phone = !x[2] && x[1] ? '+380' + x[1] : (x[1] ? '+38 (0' + x[1] + ') ' : '+380') + x[2] + (x[3] ? '-' + x[3] : '');
        },
        commercialOrder() {
            if (!this.commercialOfferData.phone) {
                this.commercialOfferDataErrors.phone = true;
                return false;
            } else {
                this.commercialOfferDataErrors.phone = false;
            }
            if (!this.commercialOfferData.email || !(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.commercialOfferData.email))) {
                this.commercialOfferDataErrors.email = true;
                return false;
            } else {
                this.commercialOfferDataErrors.email = false;
            }

            if (!this.is_disable_commercial_offer_btn) {
                this.is_disable_commercial_offer_btn = true;

                axios.post(this.route('make-offer'), {
                    type: 'KlemnyiRiadService',

                    items: this.summarize ? this.summarizeResult : this.klemyRows,
                    summarize: this.summarize,
                    project: this.project.name,

                    organization: this.commercialOfferData.organization,
                    phone: this.commercialOfferData.phone,
                    name: this.commercialOfferData.name,
                    email: this.commercialOfferData.email,
                    comment: this.commercialOfferData.comment,
                    total_price: this.totalSumm(),
                })
                .then((response) => {
                    this.commercial_offer_id = response.data.id;
                    this.commercial_offer_created_at = response.data.created_at;

                    this.commercial_offer_sended = true;

                    this.commercialOfferData.organization = null
                    this.commercialOfferData.name = null
                    this.commercialOfferData.phone = null
                    this.commercialOfferData.email = null
                    this.commercialOfferData.comment = null
                }).catch((error) => {
                    this.is_disable_commercial_offer_btn = false;
                    console.log(error);
                    window.scroll(0, 0);
                })
            }
        }
    }
};
</script>

<style scoped>
::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 15px;
    height: 15px;
    border-bottom: 1px solid #eee; 
    border-top: 1px solid #eee;
}
::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: #C3C3C3;
    border: 2px solid #eee;
}

::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2); 
}

.mobile {
    display: none;
}

a.disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}

select {
	-moz-appearance: none; 
	-webkit-appearance: none; 
	appearance: none;
    background-color: #fff;
}
#form_section {
    max-width: 1296px;
    margin: 0 auto;
}
.container {
    padding: 80px 25px 0 20px;
}
.service_header {
    display: flex;
    justify-content: space-between;
}
.avr_title {
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 43px;
    color: #212529;
}
.info_btn {
    width: 251px;
    height: 48px;
    padding: 12px 30px;
    border: 1px solid #356EEF;
    color: #356EEF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.overlay {
    z-index: 1;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.45);
}

.modal {
    position: fixed;
    z-index: 101;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    z-index: 2;
    width: 466px;
    height: auto;
    padding: 30px 30px 30px 30px;
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 15px;
    z-index: 999;
}

.modal_total {
    width: 90%;
    top: 435px;
    max-width: 1296px;
    height: 80vh;
    overflow: auto;
}

.modal_total .modal_content{
    overflow: auto;
    height: 470px;
    font-size: 14px;
    line-height: 21px;
    margin: 0px;
}
.modal_total .title{
    margin: 0px;
    padding: 0px;
    margin-bottom: 10px;
}

.modal_total table {
    table-layout: fixed;
    font-size: 14px;
    line-height: 21px;
}

.modal_header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #CED4DA;
    width: 100%;
    padding-bottom: 10px;
    position: relative;
    align-items: center;
}

.modal_header_title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    text-align: center;
    color: #000000;
    padding: 0;
    margin: 0;
}

.modal_total .modal_header_title {
    font-style: normal;
    font-weight: 400;
    font-size: 30px;
    line-height: 45px;
}

#close_modal {
    cursor: pointer;
}

.modal_content {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #151920;
    margin-top: 14px;
}

@media (max-width: 780px) {
    .container {
        padding: 50px 0 0 0;
    }
    .service_header {
        flex-direction: column;
    }
}

@media (max-width: 420px) {
    .modal {
        width: 385px;
    }
    .avr_title {
        font-size: 27px;
        line-height: 36px;
    }
}

.section_row {
    display: flex;
    gap: 75px;
}

.service_content {
    margin-top: 70px;
}

.avr_tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0;
    margin: 0;
    height: 80px;
}

.avr_tabs li {
    list-style: none;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #3A3A3A;
    /* width: 100%; */
    padding-left: 22px;
    padding-right: 22px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.result_scheme_conrtainer {
    display: flex;
    align-items: center;
    justify-content: center;
}

.result_scheme {
    max-width: 700px;
    height: auto;
    width: 100%;
    height: auto;
}

.avr_tabs li.active {
    background: #FFFFFF;
    height: 82px;
    box-shadow: inset 0px 1px 0px #DEE2E6, inset -1px 0px 0px #DEE2E6, inset 1px 0px 0px #DEE2E6;
    border-radius: 4px 4px 0px 0px;
    color: #356EEF;
}

.title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #212529;
}

.nominal_select {
    padding: 12px 16px;
    width: 200px;
    height: 48px;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}

.engine_count {
    width: 122px;
}

.metal_constr_select {
    width: 260px;
    padding-right: 40px;
}

.toggle {
	 cursor: pointer;
	 display: inline-block;
}
 .toggle__switch {
	 display: inline-block;
	 background: #FFFFFF;
    border: 1.25px solid rgba(0, 0, 0, 0.15);
    border-radius: 20px;
	 width: 40px;
	 height: 20px;
	 position: relative;
	 vertical-align: middle;
	 transition: background 0.25s;
     margin-right: 20px;
}
 .toggle__switch:before, .toggle__switch:after {
	 content: '';
}
 .toggle__switch:before {
    display: block;
    background: linear-gradient(to bottom, #fff 0%, #eee 100%);
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgb(0 0 0 / 25%);
    width: 15px;
    height: 14px;
    position: absolute;
    top: 2px;
    left: 2px;
    transition: left 0.25s;
}
 .toggle:hover .toggle__switch:before {
	 background: linear-gradient(to bottom, #fff 0%, #fff 100%);
	 box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
}
 .toggle__checkbox:checked + .toggle__switch {
	 background: #0D6EFD;
}
 .toggle__checkbox:checked + .toggle__switch:before {
	 left: 21px;
}
 .toggle__label {
	 margin-left: 5px;
	 position: relative;
	 top: 2px;
}

.btn-download {
    display: flex;
    align-items: center;
    padding: 13px 30px;
    width: 200px;
    height: 48px;
    border: 1px solid #356EEF;
    color: #356EEF;
    border-radius: 4px;
    cursor: pointer;
}
.btn-download:hover {
    background-color: #356EEF;
    color: #fff;
}
.btn-download:hover #download-icon {
    fill: #fff;
}
.btn-download svg{
    margin-right: 15px;
}

.tab_content__header {
    display: flex;
    justify-content: space-between;
}

.tab_content {
    padding: 30px;
    border: 1px solid #DEE2E6;
}

.filelist {
    padding: 0px;
    margin: 0;
    margin-bottom: 24px;
    width: 100%;
    overflow: auto;
    max-height: 245px;
}

.filelist li {
    list-style: none;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 5px;
    width: 100%;
    padding: 13px;
    background: rgba(126, 170, 255, 0.2);
    border-radius: 4px;
}

.filelist li a {
    cursor: pointer;
}
.file_item {
    display: flex;
    gap: 17px;
    width: 100%;
    color: #000000;
}

.file_item_container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-bottom: 2px solid #2F80ED;
    padding-bottom: 5px;
}

.file_item_container .file_name {
    font-size: 12px;
    line-height: 18px;
}

.download_ico {
    display: flex;
    align-items: center;
}

.download_ico {
    display: flex;
    align-items: center;
}

.tab_content__header__row {
    display: flex;
    gap: 50px;
}

.line_switcher {
    margin-top: 30px;
}

/* .line_switcher .toggle__switch {
    height: 21px;
} */

.total_btns {
    display: flex;
    gap: 30px;
}

.service_footer {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-top: 40px;
}

.view_spec_btn {
    width: 323px;
    height: 48px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
}

.download_spec {
    width: 137px;
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #000000;
    cursor: pointer;
}

/* Default Table Style */
table {
  color: #333;
  background: white;
  border: 1px solid grey;
  font-size: 12pt;
  border-collapse: collapse;
}
table thead th,
table tfoot th {
  text-align: start;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #212529;
}
table caption {
  padding:.5em;
}
table th,
table td {
    border: 1px solid #DEE2E6;
}

.line_table {
    margin-top: 40px;
    display: flex;
}

.line_table .schemes {
    margin-left: 70px;
}

.line_table .schemes .scheme_row {
    margin-bottom: 8px;
}

.line_table .schemes .first_itm {
    margin-right: 60px;
}

.line_table select {
    padding-right: 35px;
}

.line_table thead th {
    height: 72px!important;
}

.line_table tbody tr {
    height: 55px!important;
}

.line_table table {
    table-layout:fixed;
    height: 100%;
}

.delete_td {
    padding: 22px 10px 24px 20px;
}

.add_btn {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
    gap: 16px;
}

.option_select {
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: '';
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);

    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;

    border: none;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    width: 100%;
}

.count_td {
    padding: 10px 22px 10px 0px;
}

.count_td .count span {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
}

.count_td .count a {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
}

.count {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    color: #000000;
}

.count a {
    color: #000000;
}

.article {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #356EEF;
}

.article a {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #356EEF;
}

.modal_bottom {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    width: 100%;
}

.modal_bottom_link {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-decoration-line: underline;
    color: #356EEF;
    cursor: pointer;
}

.modal_bottom__btns {
    display: flex;
    align-items: center;
    gap: 30px;
}

.avr_summ_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 154px;
    height: 48px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
}

.avr_excel_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 203px;
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #000000;
    cursor: pointer;
}

.total_key {
    width: 22px;
    padding: 0;
    height: 66px;
    padding-right: 22px;
    text-align: center;
}
.total_title {
    width: 140px;
    padding: 0;
    padding-right: 22px;
    height: 66px;
}
.total_maker {
    width: 62px;
    padding: 0;
    padding-right: 22px;
    height: 66px;
}
.total_count {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 66px;
}
.total_od {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 66px;
}
.total_price {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 66px;
}
.total_summ {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 66px;
}
.total_tech {
    width: 30px;
    text-align: center;
    height: 66px;
}
.center {
    text-align: center;
    height: 66px;
}

.ol_num {
    width: 72px;
    text-align: center;
}

.ol_eq {
    width: 125px;
    max-width: 125px;
    padding-left: 15px;
    padding-right: 15px;
    text-align: center;
}

.ol_eq__select {
    width: 100px;
    max-width: 100px;
}

.ol_p_ctn {
    width: 295px;
    max-width: 295px;
    padding-left: 17px;
    padding-right: 17px;
}

.ol_p_ctn__select {
    width: 259px;
    max-width: 259px;
}

.ol_char {
    width: 133px;
    max-width: 133px;
    padding-left: 13px;
    padding-right: 13px;
}

.ol_char__select {
    width: 166px;
    max-width: 166px;
}

.ol_curr {
    width: 137px;
    max-width: 137px;
    padding-left: 16px;
    padding-right: 16px;
}

.ol_curr__select {
    width: 148px;
    max-width: 148px;
}

.ol_cnt {
    width: 157px;
    padding-left: 16px;
    padding-right: 16px;
    text-align: center;
}

.ol_article {
    width: 172px;
    max-width: 172px;
    padding-left: 22px;
}

.ol_close {
    width: 46px;
    padding-left: 16px;
}

.summ_point {
    height: 44px;
    text-align: end;
    padding-right: 22px;
}

.summ_value {
    text-align: center;
    padding-right: 22px;
}

.modal_total table th, .modal_total table td, .modal_total table {
    border: none;
}
.modal_total thead {
    border-bottom: 1.5px solid #356EEF;
}
.modal_total tr {
    border-bottom: 1px solid #C8E4FF;
}
.modal_total tr:hover {
    background-color: #F0F8FF;
}
.modal_total .modal_header {
    border-bottom: none;
}

.summ_text {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}

.next a {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;    
}

.cat_name {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #919299;
    background: none!important;
    padding: 0!important;
}

.description_modal .modal_header {
    border-bottom: none;

}

.form_label {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
}

.input_group {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 18px;
}

.form_radio {
    width: 18px;
    height: 18px;
    min-width: 18px;
    padding: 0;
    margin: 0;
    cursor: pointer;
}

.selected_value {
    margin-left: 18px;
    font-weight: 400;
    cursor: pointer;
}

input[type='checkbox']::before{
    content: "";
    display: block;
    width: 0.9rem;
    height: 0.9rem;
    border: 2px solid #356EEF;
    border-radius: 3px;
}

.docs {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
}
.scheme {
    display: flex;
    align-items: center;
    gap: 12px;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #356EEF;
}

@media (max-width: 1190px) {
    .next {
        width: 120px!important;
    }
    .avr_tabs li {
        width: 100%;
        padding: 0;
        font-size: 14px;
        line-height: 22px;
    }

    .schemes {
        display: none;
    }
}

@media (max-width: 1180px) {
    .service_header {
        flex-direction: column;
        gap: 20px;
    }
    .tab_content__header {
        flex-direction: column;
        gap: 15px;
        margin-bottom: 20px;
    }
    .service_footer {
        flex-direction: column;
        align-items: start;
        gap: 40px;
    }
    .total_btns {
        justify-content: space-between;
        width: 100%;
    }
    .view_spec_btn, .download_spec {
        width: 50%;
    }
    .next {
        width: 120px!important;
    }
    .prev_btn {
        rotate: 180deg;
    }
    .totals_summs {
        gap: 40px;
    }
}
@media (max-width: 960px) {
    .total_key {
        width: 30px;
    }
    .total_title {
        padding-top: 15px;
        padding-bottom: 15px;
        width: 280px;
    }
    .total_maker {
        width: 125px;
    }
    .total_count {
        width: 90px;
    }
    .total_od {
        width: 90px;
    }
    .total_price {
        width: 90px;
    }
    .total_summ {
        width: 90px;
    }
    .total_tech {
        width: 90px;
    }
    .line_table {
        overflow-x: scroll;
        -webkit-overflow-scrolling: auto;
    }
    .line_table table {
        width: 100%;
    }
    .main_table_container {
        width: 100%;
        overflow: auto;
    }
    .main_table_title {
        min-width: 120px;
    }
    .main_table_row {
        text-wrap: nowrap;
    }
    .avr_title {
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: 38.4px;
    }
    h4.title_edited {
        font-size: 22px;
        font-style: normal;
        font-weight: 500;
        line-height: 33px;
    }
    .spec_title {
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 27px;
    }
    .item_text {
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;
    }
    .totals_summs {
        flex-direction: column-reverse;
        align-items: baseline;
        gap: 30px;
    }
    .total_prices, .total_btns {
        width: 100%!important;
    }
    .total_btns {
        justify-content: left;
    }
    .total_btns .download_spec {
        width: 156px;
    }
    .items_bottom .view_spec_btn {
        width: auto;
        padding: 0 20px;
    }
    .filter_select_badges {
        display: block!important;
    }
    .badge_select_container {
        display: inline-block;
        margin-right: 15px;
        margin-bottom: 15px;
    }
    .filter_badges {
        display: block!important;
    }
    .badge_container {
        display: inline-block;
        margin-bottom: 15px;
        margin-right: 15px;
    }
    .edit_title_input {
        width: auto!important;
    }
}
@media (max-width: 768px) {
    .filter_section_header_title_container {
        flex-direction: column;
        align-items: baseline!important;
    }
    .item_header {
        overflow-x: auto;
        overflow-y: hidden;
    }
}
@media (max-width: 567px) {
    .search_input input {
        width: auto!important;
    }
}
@media (max-width: 450px) {
    .mobile {
        display: block!important;
    }
    .tab_content__header__row {
        flex-direction: column;
        gap: 15px;
    }
    .service_footer {
        gap: 30px;
        margin-top: 30px;
    }
    .total_btns {
        flex-direction: column;
    }
    .view_spec_btn, .download_spec {
        width: 100%;
    }
    .avr_tabs li {
        font-size: 16px;
        line-height: 24px;
    }
    .avr_tabs li.active {
        height: 82px;
    }
    .modal_bottom {
        flex-direction: column-reverse;
        gap: 20px;
        text-align: center;
    }
    .service_content {
        margin-top: 50px;
    }
    .modal_total {
        height: 655px;
        top: 350px;
    }
    .modal_total .modal_content {
        height: 355px;
    }
    .modal_bottom {
        padding-top: 25px;
    }
    .metal_constr_select, .service_header .info_btn, .service_footer .nominal_power, .avr_summ_btn, .avr_excel_btn{
        width: 100%;
    }
    .service_header .info_btn {
        justify-content: center;
        height: 34px;
        padding: 8px 12px;
        width: fit-content;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
    }
    .tab_content {
        padding: 20px;
    }
    .modal_bottom__btns {
        flex-direction: column;
        gap: 20px;
    }
    .next {
        width: 90px!important;
    }
    .section_row {
        flex-direction: column;
        gap: 35px;
    }
    .engine_count {
        width: 100%;
    }
    .edit_title_container {
        flex-direction: column;
    }
    .edit_title_container_btns .save_title_btn, .edit_title_container_btns .cancel_title_btn {
        width: 100%;
    }
    .service_header {
        flex-direction: column-reverse;
    }
    .avr_title {
        color: #212529;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 28px;
        margin: 0px;
    }
    h4.title_edited {
        font-size: 18px!important;
        font-weight: 700!important;
        line-height: 25.2px!important;
        margin-top: 16px;
        margin-bottom: 16px;
    }
    .edit_title_container {
        margin-top: 16px!important;
    }
    .spec_title {
        margin-top: 16px;
        margin-bottom: 16px;
    }
    .item_header-actions {
        display: none!important;
    }
    .title_edited {
        width: auto!important;
    }
    .item_header {
        border-radius: 8px;
        background: rgba(77, 77, 77, 0.09);
        height: auto!important;
    }
    .items {
        padding-top: 12px;
    }
    .arrow_opened:hover {
        background: none!important;
    }
    .item_header-title {
        flex-direction: row-reverse;
        width: 100%;
        justify-content: space-between;
        padding: 0px 12px;
    }
    .item_text {
        display: none;
    }
    .item_header {
        flex-direction: column;
    }
    .item_header_info {
        width: 100%;
        padding: 0px 12px;
        margin-top: 12px;
    }
    .item_text.mobile {
        color: #000;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .item_header_info_actions {
        display: flex;
        justify-content: space-between;
    }
    .item_header_info_actions .action-add, .item_header_info_actions .action-delete {
        display: flex;
        align-items: center;
        color: #000;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;
        gap: 2px;
    }
    .total_btns .download_spec {
        width: 100%!important;
    }
    #items .main_table {
        display: none;
    }
    #items {
        border: none;
    }
    #items .item_drop, #items .items_bottom {
        padding: 0px;
    }
    .mobile_acessories_list_item {
        border-bottom: 1px solid rgba(0, 0, 0, 0.10);
    }
    .mobile_acessories_list_item.active {
        border: 1px solid rgba(0, 0, 0, 0.20);
        border-radius: 8px;
        padding: 8px;
        margin-bottom: 12px;
    }
    .mobile_acessories_list_item_header {
        display: flex;
        align-items: center;
        gap: 5px;
        padding: 12px 0px;
    }
    .mobile_acessories_list_item_header svg {
        min-width: 24px;
    }
    .mobile_acessories_list_item.active .mobile_acessories_list_item_header{
        border-bottom: 1px solid rgba(0, 0, 0, 0.10);
    }
    .mobile_acessories_list_item.active .mobile_acessories_list_item_header svg {
        rotate: 180deg;
    }
    .mobile_acessories_list_item_content {
        margin-top: 12px;
    }
    .mobile_acessories_list_item_content_row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
    }
    .mobile_acessories_list_item_content_row .main_table_count_input {
        font-weight: 700;
    }
    .mobile_acessories_list_item_content_row.active {
        background: #EFF4FE;
    }
    .mobile_acessories_list_item_content_row.added {
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--body-text-body-color, #212529);
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        background: #EFF4FE;
    }
    .acessory_item_added_container {
        display: flex;
        padding: 4px;
        justify-content: center;
        align-items: center;
        gap: 8px;
    }
    .mobile_acessories_list_copy_btn {
        display: flex;
        align-items: center;
        padding: 4px 8px;
        gap: 6px;
        border-radius: 4px;
        background: rgba(53, 110, 239, 0.14);
        color: #000;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        width: max-content;
        margin-top: 12px;
        width: 100%;
    }
    .summ_items_container {
        padding: 0px!important;
    }
    .item_drop.active {
        border-radius: 8px;
        border: 1px solid rgba(0, 0, 0, 0.20);
        padding: 12px!important;
    }
    .item_drop:not(.active):not(:last-child) {
        border-bottom: none!important;
    }
    .item_drop_container {
        display: flex;
        flex-direction: column;
        gap: 12px;
        border-radius: 8px;
        border: 1px solid rgba(0, 0, 0, 0.20);
        padding: 12px!important;
    }
    .item_drop_container.disabled {
        border-radius: 0px;
        border: none;
        padding: 0px!important;
    }
    .add_item_btn {
        width: 100%!important;
    }
    .items_bottom .view_spec_btn {
        padding: 0 12px;
    }

    #klemy, #acessories {
        display: none;
    }

    .filter_section {
        display: flex;
        align-items: center;
        gap: 12px;
    }
    .mobile_filter_ico {
        border-radius: 4px;
        background: #356EEF;
        height: 40px;
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }
    .filter_pointer {
        position: absolute;
        top: -5px;
        right: -5px;
    }

    .filter_section .search_input, .filter_section .search_input input {
        width: 100%!important
    }
    .tab_section_header_item {
        color: #000;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
        width: 50%;
        text-align: center;
        padding-bottom: 11px;
        border-bottom: 2px solid #D9D9D9;
    }
    .tab_section_header_item.active {
        font-weight: 600;
        border-bottom: 2px solid #356EEF;
    }
    .tab_section_header {
        display: flex;
        justify-content: space-between;
    }
    .filter_section {
        margin-top: 15px!important;
    }
    .items {
        margin-bottom: 30px!important;
    }
    .acessory_tab .mobile_acessories_list_item_container {
        margin-top: 12px;
    }
    .klemy_tab .mobile_acessories_list_item_container {
        margin-top: 12px;
    }

    .selected_filter_container {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .selected_filter_container .filter_klema_title {
        color: #000;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
    }

    .acessory_tab .mobile_acessories_list_item.active .mobile_acessories_list_item_header{
        border-bottom: 1px solid rgba(0, 0, 0, 0.10);
        background: #F5F5F5;
        color: #000;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        padding: 12px 3px;
    }
    .klemy_tab .mobile_acessories_list_item.active .mobile_acessories_list_item_header{
        border-bottom: 1px solid rgba(0, 0, 0, 0.10);
        background: #F5F5F5;
        color: #000;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        padding: 12px 3px;
    }

    .klemy_tab .badge_container {
        margin-top: 12px;
        width: 100%;
        margin-bottom: 0px!important;
    }

    .klemy_tab .badge_container .badge {
        justify-content: space-between;
    }

    .acessory_tab .badge_container {
        margin-top: 12px;
        width: 100%;
        margin-bottom: 0px!important;
    }

    .acessory_tab .badge_container .badge {
        justify-content: space-between;
    }

    .table_pagination_container {
        justify-content: space-between!important;
    }

    .table_pagination {
        gap: 5px!important;
    }

    .pagination_bnt {
        width: 48px!important;
        height: 48px!important;
    }

    .table_pagination_pages {
        height: 48px!important;
    }
}
@media (max-width: 400px) {
    .modal_total {
        height: 666px;
    }
}
@media (max-width: 390px) {
    .modal_total {
        width: 330px;
    }
    .description_modal, .docs_modal {
        width: 330px;
    }
    .next {
        width: 75px!important;
    }
}
@media (max-width: 360px) {
    .next {
        width: 60px!important;
    }
}
@media only screen and (max-height: 740px) and (min-width: 1200px) {
    .modal_total {
        top: 360px;
    }
    .modal_total .modal_content {
        height: 370px;
    }
}

.items {
    border-radius: 4px;
    border: 1px solid #E5E5E5;
    margin-bottom: 45px;
    padding-bottom: 12px;
}

.item_drop {
    padding: 0px 12px;
    cursor: pointer;
}

.item_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 45px;
    padding-bottom: 12px;
    padding-top: 12px;
}
.item_drop:not(:last-child) {
    border-bottom: 1px solid #E6E6E6;
}
.item_header-title {
    display: flex;
    align-items: center;
    color: #000;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    gap: 5px;
}
.item_header-actions {
    display: flex;
    gap: 16px;
}
.add_item_btn {
    display: flex;
    width: 306px;
    padding: 8px 12px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    border-radius: 4px;
    border: 1px solid #356EEF;
    margin-top: 12px;
    margin-bottom: 12px;
}
.item_content {
    margin-top: 12px;
    margin-bottom: 12px;
}

.main_table {
    width:100%;
    border-radius: 4px 4px 0px 0px;
}

.main_table, th, td {
  border: 1px solid #DEE2E6;
  border-collapse: collapse;
}

.main_table_title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #212529;
    height: 54px;
    background: #FAFAFA;
}

.main_table_row {
    height: 53px;
}

.main_table tr:hover {
    background: #EFF4FE;
}

.main_table tr.active {
    background: #EFF4FE;
}

.main_table_count_input {
    width: 60px;
    height: 36px;
    background: #FFFFFF;
    border: 1px solid #DEE2E6;
    border-radius: 6px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #000000;
}

.edit_row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
}

.total_btns {
    display: flex;
    gap: 26px;
}
.totals_summs {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    border-radius: 4px;
    border: 1px solid #E5E5E5;
    padding: 12px;
}
.total_btns {
    width: 60%;
}
.total_prices {
    width: 40%;
}
.total_prices_price {
    display: flex;
    justify-content: space-between;
}
.total_prices_price p {
    margin: 0;
}
.price_num {
    color: #000;
    text-align: right;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.filter_section {
    margin-top: 40px;
}
.filter_section_header {
    display: flex;
    justify-content: space-between;
}
.search_input {
    position: relative;
}
.search_input input {
    width: 307px;
    padding: 6px 16px;
    padding-right: 40px;
    height: 40px;
    background: #FFFFFF;
    border: 1px solid #C8E4FF;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
}
.search_input svg {
    position: absolute;
    right: 10px;
    top: 7px;
}
.filter_select_badges {
    display: grid;
    gap: 5px;
    grid-auto-flow: column;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
}
.filter_badges {
    display: grid;
    grid-auto-flow: column;
    gap: 10px;
    overflow: hidden;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
}
.filter_badges_part {
    overflow: hidden;
    width: 100%;
    margin-bottom: 20px;
}
.table_pagination_container {
    display: flex;
    justify-content: flex-end;
    margin-top: 15px;
}
.table_pagination {
    display: flex;
    align-items: center;
    gap: 20px;
}
.table_pagination_pages {
    display: inline-flex;
    height: 24px;
    padding: 2px 10px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.10);
    cursor: pointer;
}
.pagination_bnts {
    display: flex;
    gap: 16px;
}
.pagination_bnt {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.10);
}
.arrow_opened.opened {
    rotate: 180deg;
}
.arrow_opened:hover {
    background: #F5F6F8;
}
.items_bottom {
    padding: 0px 12px;
}
.edit_title_container {
    display: flex;
    gap: 10px;
}
.edit_title_container_btns {
    display: flex;
    gap: 10px; 
}
.edit_title_input {
    border-radius: 4px;
    border: 1px solid #356EEF;
    width: 350px;
    padding: 0px 6px;
    height: 30px;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
}
.save_title_btn {
    width: 85px;
    height: 30px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
}
.cancel_title_btn {
    width: 85px;
    height: 30px;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #000000;
    cursor: pointer;
}
.title_edited {
    width: 350px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.title_edited:hover {
    border-radius: 4px;
    background: #F5F6F8;
}

.badge_container {
    display: inline-block;
    margin-bottom: 12px;
    min-width: 0;
    position: relative;
}
.badge {
    width: 100%;
    display: flex;
    padding: 8px 16px;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: 1px solid var(--system-gray-03, #CED4DA);
    cursor: pointer;
    color: rgba(0, 0, 0, 0.90);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.badge_info_containers {
    display: flex;
}
.badge.active {
    background: #EFF4FE;
}
.filter_section_header_title_container {
    display: flex;
    align-items: center;
    gap: 25px;
}
.badge.active {
    background: #EFF4FE;
}
.clear_input {
    cursor: pointer;
}
.confirm_buttons {
    display: flex;
    gap: 20px;
}
.confirm_button_cancel {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #356EEF;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
}
.confirm_button_confirm {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #FFF;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.30);
}
.modal_confirm_content {
    color: rgba(0, 0, 0, 0.90);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 28.8px;
    margin-bottom: 30px;
}
.count_container, .klema_ryad_select_container {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
}
.klema_ryad_select_container {
    align-items: start;
    flex-direction: column;
}
.form_select {
    padding: 10px 16px;
    width: 100%;
    height: 48px;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}
.summ_items_container {
    padding: 12px;
}
.klema_filters_container {
    display: flex;
    gap: 32px;
}
.klema_filters_container .klemy {
    margin-top: 0px;
}
.badge_select_value label {
    display: flex;
    gap: 10px;
    padding: 10px 10px;
    cursor: pointer;
}
.acessory_item_modal .badge_select_value label {
    padding: 10px 0px;
}
.badge_select_value label:hover {
    background: #EFF4FE;
}

.klema_filters_container .klema_filters {
    margin-top: 20px;
}

.klema_filters_container .acessory_filters {
    margin-top: 20px;
}
.klema_filters_container .klema_filters .klema_item {
    margin-bottom: 20px;
}

.klemy_filter_items, .acessory_filter_items {
    max-height: 320px;
    overflow: auto;
}

.acessory_filter_title {
    border-top: 1px solid #DEE2E6;
    padding-top: 20px;
}

.klema_filter_title, .acessory_filter_title, .acessory_filter_title2 {
    color: #000;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
}

.filter_modal .klema_item {
    margin-bottom: 10px;
    border-radius: 4px;
    border: 1px solid var(--system-gray-03, #CED4DA);
    background: #FFF;
    padding: 12px;
}

.filter_modal .modal_header {
    border-bottom: none!important;
}

.klema_item_dop_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.klema_item_dop_header.active {
    padding-bottom: 12px;
    border-bottom: 1px solid #D9D9D9;
}
.klema_item_dop_header h5 {
    margin-bottom: 0px;
}
.klema_item_dop_header svg:hover {
    cursor: pointer;
}

.klema_sub_filter_title {
    color: rgba(0, 0, 0, 0.90);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
}
.sub_filter_select_title {
    color: rgba(0, 0, 0, 0.90);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
}
.badge_title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.options_container {
    max-height: 400px;
    overflow-x: auto;
    padding-top: 15px;
    margin-bottom: 25px;
}
.selected_filter_count {
    border-radius: 2px;
    background: rgba(53, 110, 239, 0.12);
    color: #000;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
}
.clear_klema_filters {
    display: flex;
    justify-content: flex-end;
    padding-top: 10px;
}
.clear_klema_filter {
    display: flex;
    align-items: center;
}

.commercial_offer_header {
    border-radius: 4px;
    background: rgba(200, 228, 255, 0.45);
    padding: 24px 16px;
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    cursor: pointer;
}
.commercial_offer_header_title {
    color: #1C1C1C;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
}
.commercial_offer_drop_row {
    rotate: 180deg;
}
.commercial_offer_body {
    padding: 0px 16px 24px 16px;
    background: rgba(200, 228, 255, 0.45);
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}
.flex-row, .flex-group {
    display: flex;
    flex-direction: row;
    gap: 24px;
}
.customer_info .form_input {
    max-width: 100%;
}
.flex_form {
    width: 100%;
}
.form_grid {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
}
.form_group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
}
.form_label {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
}
.form_input {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding: 10px 16px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    max-width: 200px;
    height: 100%;
}
.error_text {
    color: red;
}
.form_textarea {
    max-width: 100%;
    height: auto;
}
.textarea_container {
    position: relative;
}
.total_words {
    position: absolute;
    right: 5px;
    bottom: 5px;
    color: rgb(95,99,104);
    font-size: 14px;
}
.commercial_offer_body .form_textarea {
    resize: none;
    width: 100%;
}
.commercial_offer_order_btn {
    border-radius: 4px;
    background: #356EEF;
    width: 282px;
    height: 48px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-top: 24px;
}
.commercial_offer_order_btn.disabled {
    background: #CED4DA;
}
.block_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
#close_offer {
    cursor: pointer;
}
.commercial_offer_order_title {
    color: #212529;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
    margin: 0px;
}
.commercial_offer_order {
    margin-top: 24px;
    border-radius: 4px;
    border-left: 4px solid #356EEF;
    background: #FFF;
    padding: 16px;
}
.article_copy {
    color: #212529;
    cursor: copy;
}
.commercial_offer_order_text {
    margin-top: 12px;
}
@media (max-width: 1200px) {
    .customer_info {
        flex-direction: column;
    }
    .form_input {
        width: 100%!important;
    }
}
@media (max-width: 600px) {
    .flex-row {
        flex-direction: column!important;;
    }
    .commercial_offer_order_btn {
        width: 100%;
    }
}
</style>
